{
  "common": {
    "loading": "Loading...",
    "loadingLabel": "Loading",
    "readOnlyHint": "Click 'Edit {{entity}}' under Actions to unlock fields for editing. Some fields cannot be changed after creation.",
    "unsavedChangesTitle": "Discard unsaved changes?",
    "unsavedChangesDescription": "You have unsaved changes. If you continue, your edits will be lost.",
    "keepEditing": "Keep editing",
    "discardChanges": "Discard changes",
    "switchLanguage": "Switch language",
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "viewDetails": "View details",
    "create": "Create",
    "search": "Search",
    "filter": "Filter",
    "actions": "Actions",
    "confirm": "Confirm",
    "back": "Back",
    "next": "Next",
    "submit": "Submit",
    "close": "Close",
    "yes": "Yes",
    "no": "No",
    "error": "Error",
    "success": "Success",
    "minutes": "min",
    "warning": "Warning",
    "info": "Info",
    "all": "All",
    "view": "View",
    "add": "Add",
    "update": "Update",
    "remove": "Remove",
    "status": "Status",
    "active": "Active",
    "inactive": "Inactive",
    "blacklisted": "Blacklisted",
    "pending": "Pending",
    "completed": "Completed",
    "current": "Current",
    "upcoming": "Upcoming",
    "name": "Name",
    "more": "more",
    "description": "Description",
    "image": "Image",
    "noImage": "No image",
    "createdAt": "Created",
    "updatedAt": "Updated",
    "email": "Email",
    "phone": "Phone",
    "viewMode": {
      "tabs": "Cards",
      "list": "List"
    },
    "select": "Select",
    "quickActions": "Quick Actions",
    "deleted": "Deleted successfully",
    "confirmDelete": "Confirm Delete",
    "confirmDeleteDescription": "This action cannot be undone. Are you sure you want to delete this item?",
    "firstName": "First Name",
    "lastName": "Last Name",
    "cost": "Cost",
    "date": "Date",
    "details": "Details",
    "download": "Download",
    "dragToReorder": "Drag to reorder",
    "export": "Export",
    "loadMore": "Load more",
    "notFound": "Not found.",
    "print": "Print",
    "appName": "Care of Cars",
    "saved": "Saved successfully",
    "saving": "Saving...",
    "scrollLeft": "Scroll left",
    "scrollRight": "Scroll right",
    "today": "Today",
    "previous": "Previous",
    "previousMonth": "Previous month",
    "nextMonth": "Next month",
    "previousWeek": "Previous week",
    "nextWeek": "Next week",
    "clear": "Clear",
    "moreOptions": "More options",
    "help": "Help",
    "decrease": "Decrease",
    "searchEmployee": "Search employee...",
    "required": "Required",
    "regNumberPlaceholder": "ABC 123",
    "type": "Type",
    "failed": "Failed",
    "weekDays": {
      "monday": "Monday",
      "tuesday": "Tuesday",
      "wednesday": "Wednesday",
      "thursday": "Thursday",
      "friday": "Friday",
      "saturday": "Saturday",
      "sunday": "Sunday"
    }
  },
  "admin": {
    "confirmDeleteUser": "Delete {{name}}? This cannot be undone.",
    "confirmDeleteRole": "Delete {{name}}? This cannot be undone.",
    "confirmDeleteOrg": "Delete {{name}}? This cannot be undone.",
    "confirmDeleteSalesCompany": "Delete {{name}}? This cannot be undone.",
    "confirmDeletePlan": "Delete plan {{name}}? This cannot be undone.",
    "subscriptionForm": {
      "orgRequired": "Organization is required",
      "planRequired": "Plan is required",
      "validFromRequired": "Valid from date is required",
      "validToRequired": "Valid to date is required",
      "discountMustBeInteger": "Discount per user must be a whole number"
    },
    "planForm": {
      "nameRequired": "Name is required",
      "currencyRequired": "Currency is required",
      "currencyMaxLength": "Currency code must be at most 3 characters",
      "descriptionRequired": "Description is required"
    },
    "discountForm": {
      "orgRequired": "Organization is required",
      "featureRequired": "Feature is required",
      "validFromRequired": "Valid from date is required",
      "validToRequired": "Valid to date is required",
      "reasonRequired": "Reason is required"
    },
    "featureForm": {
      "nameRequired": "Name is required",
      "unitRequired": "Unit is required",
      "unitTooLong": "Unit must be at most 50 characters",
      "costMustBeInteger": "Cost must be a whole number"
    },
    "globalRoleForm": {
      "nameRequired": "Name is required"
    },
    "globalPermissionForm": {
      "titleMinLength": "Title must be at least 3 characters",
      "titlePattern": "Lowercase letters, digits and .:_- only"
    },
    "automationTriggerForm": {
      "keyRequired": "Event key is required",
      "keyPattern": "Lowercase, dot-separated words only, e.g. order.created",
      "nameRequired": "Name is required",
      "categoryRequired": "Category is required",
      "formLabel": "Automation trigger form",
      "keyLabel": "Event key",
      "nameLabel": "Name",
      "descriptionLabel": "Description",
      "categoryLabel": "Category",
      "selectCategory": "Select category",
      "activeLabel": "Active"
    },
    "automationMappingForm": {
      "orgRequired": "Organization is required",
      "triggerRequired": "Automation trigger is required",
      "templateRequired": "Select at least one template",
      "formLabel": "Automation mapping form",
      "orgLabel": "Organization",
      "selectOrg": "Select organization",
      "actionLabel": "Action",
      "selectAction": "Select action",
      "emailTemplateLabel": "Email template",
      "smsTemplateLabel": "SMS template",
      "selectOrgFirst": "Select organization first",
      "noneOption": "None",
      "activeLabel": "Active"
    },
    "automations": {
      "title": "Communication automations",
      "description": "The catalog of triggers orgs can automate, and which org has wired which trigger to an email/SMS template.",
      "triggersTab": "Triggers",
      "mappingsTab": "Org mappings",
      "saveChanges": "Save changes",
      "columnTrigger": "Trigger",
      "columnEventKey": "Event key",
      "columnCategory": "Category",
      "columnOrganization": "Organization",
      "columnEmailTemplate": "Email template",
      "columnSmsTemplate": "SMS template",
      "newTrigger": "New trigger",
      "editTrigger": "Edit trigger",
      "createTrigger": "Create trigger",
      "noTriggers": "No automation triggers yet.",
      "triggerCreated": "Trigger created",
      "triggerUpdated": "Trigger updated",
      "triggerDeleted": "Trigger deleted",
      "triggerSaveFailed": "Failed to save trigger",
      "triggerDeleteFailed": "Failed to delete trigger",
      "deleteTriggerTitle": "Delete {{name}}?",
      "deleteTriggerDescription": "This also removes every org mapping that uses this trigger.",
      "newAutomation": "New automation",
      "editAutomation": "Edit automation",
      "createAutomation": "Create automation",
      "noMappings": "No org mappings yet.",
      "mappingCreated": "Mapping created",
      "mappingUpdated": "Mapping updated",
      "mappingDeleted": "Mapping deleted",
      "mappingSaveFailed": "Failed to save mapping",
      "mappingDeleteFailed": "Failed to delete mapping",
      "deleteMappingTitle": "Delete mapping for {{orgName}} — {{triggerName}}?",
      "deleteMappingDescription": "This action cannot be undone."
    }
  },
  "nav": {
    "dashboard": "Dashboard",
    "scheduler": "Scheduler",
    "booking": "Booking",
    "customers": "Customers",
    "vehicles": "Vehicles",
    "services": "Services",
    "jobs": "Jobs",
    "pricing": "Pricing",
    "roles": "Roles & Permissions",
    "settings": "Settings",
    "account": "Account",
    "changePassword": "Change Password",
    "home": "Home",
    "mainMenu": "Main Menu",
    "system": "System",
    "mainNavigation": "Main navigation",
    "homeAriaLabel": "Care of Cars - Home",
    "primaryNavigation": "Primary navigation",
    "expandSidebar": "Expand sidebar",
    "collapseSidebar": "Collapse sidebar",
    "userMenu": "User menu",
    "leaves": "Leaves",
    "workLogs": "Work Logs",
    "myWork": "My Workspace",
    "myWorkspace": "My Workspace",
    "teamOverview": "Employee Approvals",
    "billing": "Invoicing",
    "economy": "Economy",
    "products": "Products",
    "rentalFleet": "Rental Fleet",
    "campaigns": "Campaigns",
    "communication": "Communication",
    "reviews": "Reviews",
    "categories": "Categories",
    "integrations": "Integrations",
    "hrSection": "HR",
    "businessSection": "Business"
  },
  "auth": {
    "login": "Login",
    "logout": "Logout",
    "register": "Register",
    "signIn": "Sign In",
    "signUp": "Sign Up",
    "signOut": "Sign Out",
    "email": "Email",
    "password": "Password",
    "confirmPassword": "Confirm Password",
    "forgotPassword": "Forgot Password?",
    "forgotPasswordLink": "Go to forgot password page",
    "resetPassword": "Reset Password",
    "rememberMe": "Remember me for 30 days",
    "rememberMeHint": "Keep me signed in for 30 days",
    "noAccount": "Don't have an account?",
    "hasAccount": "Already have an account?",
    "createAccount": "Create Account",
    "createAccountLink": "Go to registration page",
    "requestAccessMessage": "Access is by invitation only. Contact your administrator.",
    "welcome": "Welcome",
    "enterCredentials": "Enter your credentials to access your account",
    "name": "Name",
    "fullName": "Full Name",
    "loginForm": "Login form",
    "loginFailed": "Login failed. Please check your credentials.",
    "noRoleAssigned": "Your account has no role assigned in this organization yet, so menu access can't be loaded. Contact your administrator.",
    "showPassword": "Show password",
    "hidePassword": "Hide password",
    "passwordToggleHint": "Toggle password visibility",
    "emailHint": "Enter your email address",
    "emailPlaceholder": "you@example.com",
    "brandingSection": "Brand information",
    "manageBusinessTitle": "Manage Your Auto Service Business",
    "manageBusinessDesc": "Streamline operations, track jobs, manage customers, and grow your business with our comprehensive solution.",
    "forgotPasswordTitle": "Forgot password?",
    "forgotPasswordDesc": "No worries, we'll send you reset instructions.",
    "sendResetLink": "Send reset link",
    "checkYourEmail": "Check your email",
    "resetLinkSentDesc": "We sent a password reset link to",
    "resendEmail": "Didn't receive email? Resend",
    "backToLogin": "Back to login",
    "setNewPassword": "Set new password",
    "setNewPasswordDesc": "Your new password must be different from previously used passwords.",
    "newPassword": "New Password",
    "passwordMinLength": "Must be at least 8 characters",
    "passwordRequired": "Password is required",
    "confirmPasswordRequired": "Please confirm your password",
    "passwordsDoNotMatch": "Passwords do not match",
    "emailRequired": "Email is required",
    "emailInvalid": "Enter a valid email address",
    "resetPasswordButton": "Reset password",
    "passwordResetSuccess": "Password reset successful",
    "passwordResetSuccessDesc": "Your password has been successfully reset. You can now sign in with your new password.",
    "continueToLogin": "Continue to login",
    "acceptInvite": {
      "title": "Accept Invitation",
      "description": "Confirming your invitation, please wait...",
      "success": "Invitation accepted",
      "successDesc": "You've joined the organization as {{email}}.",
      "error": "This invite link is invalid, expired, or has already been used.",
      "loginPrompt": "Sign in with the account matching your invited email address to accept this invitation."
    }
  },
  "org": {
    "switchOrganization": "Switch organization",
    "selectOrganization": "Select organization",
    "selectOrgDescription": "Choose which organization you'd like to work with",
    "organizations": "Organizations",
    "organization": "Organization"
  },
  "store": {
    "stores": "Stores",
    "mainStore": "Main Store",
    "primary": "Primary",
    "noStores": "No stores available"
  },
  "notifications": {
    "title": "Notifications",
    "viewAll": "View all notifications",
    "noNotifications": "No notifications",
    "newJobAssigned": "New job assigned",
    "upcomingAppointment": "Upcoming appointment reminder",
    "scheduleChange": "Schedule has been updated",
    "paymentReceived": "Customer payment received",
    "serviceCompleted": "Vehicle service completed"
  },
  "user": {
    "profile": "Profile",
    "myAccount": "My Account",
    "settings": "Settings",
    "language": "Language"
  },
  "errors": {
    "notFound": "Page not found",
    "notFoundMessage": "Oops! The page you're looking for doesn't exist.",
    "returnHome": "Return to Home",
    "somethingWentWrong": "Something went wrong",
    "tryAgain": "Try again",
    "unauthorized": "Unauthorized",
    "forbidden": "Access denied",
    "accessDenied": "Access Denied",
    "accessDeniedMessage": "You don't have permission to view this page. Please contact your administrator if you believe this is a mistake.",
    "unexpectedErrorOccurred": "An unexpected error occurred"
  },
  "topbar": {
    "howTo": "How to use",
    "searchPlaceholder": "Search reg-no...",
    "new": "New",
    "dashboardSubtitle": "Overview of your service center",
    "schedulerSubtitle": "Manage daily schedules and assignments",
    "bookingSubtitle": "View and manage all appointments",
    "newBookingSubtitle": "Create a new service appointment",
    "customersSubtitle": "Manage your customer database",
    "newCustomerSubtitle": "Register a new customer",
    "newCompanySubtitle": "Register a new company account",
    "vehiclesSubtitle": "Track registered vehicles",
    "newVehicleSubtitle": "Add a vehicle to the registry",
    "servicesSubtitle": "Manage your service catalog",
    "newServiceSubtitle": "Create a new service offering",
    "jobsSubtitle": "Track work orders and service jobs",
    "pricingSubtitle": "Manage service pricing and margins",
    "rolesSubtitle": "Configure roles and access control",
    "settingsSubtitle": "System preferences and configuration",
    "accountSubtitle": "Manage your personal account",
    "leavesSubtitle": "Track and manage employee leave",
    "workLogsSubtitle": "Monitor daily work hours",
    "billingSubtitle": "Manage invoices and payments",
    "productsSubtitle": "Manage product inventory",
    "newProductSubtitle": "Add a new product to inventory",
    "rentalFleetSubtitle": "Manage rental vehicle fleet",
    "campaignsSubtitle": "Create and track marketing campaigns",
    "integrationsSubtitle": "Connect tools and services"
  },
  "theme": {
    "toggle": "Toggle theme",
    "light": "Switch to light mode",
    "dark": "Switch to dark mode"
  },
  "dashboard": {
    "title": "Dashboard",
    "welcome": "Welcome back",
    "welcomeMessage": "Here's an overview of your service center.",
    "overview": "Overview",
    "recentJobs": "Recent Jobs",
    "quickActions": "Quick Actions",
    "weeklyNotes": "Weekly Notes",
    "weeklyTeamBoard": "Weekly Team Board",
    "weekLabel": "Week {{week}}, {{year}}",
    "addNote": "Add Note",
    "notePlaceholder": "Enter your note...",
    "noNotes": "No notes for this week",
    "noNotesDay": "No notes",
    "addNoteHint": "Click 'Add Note' to create one",
    "goToCurrentWeek": "Go to current week",
    "weeklySummary": "Weekly Summary",
    "weeklySummaryPlaceholder": "Add a summary note for the week...",
    "dailyNotePlaceholder": "Add a note for this day...",
    "todayBadge": "Today",
    "today": {
      "bookings": "TODAY'S BOOKINGS",
      "revenue": "REVENUE (TODAY)",
      "activeCustomers": "ACTIVE CUSTOMERS",
      "utilization": "UTILIZATION"
    },
    "saveNotes": "Save Notes",
    "executiveKPIs": "Executive KPIs",
    "statisticsAnalytics": "Statistics & Analytics",
    "performanceMetrics": "Performance metrics and business intelligence",
    "manageWeeklyNotes": "Manage weekly notes",
    "stats": {
      "totalCustomers": "Total Customers",
      "vehiclesRegistered": "Vehicles Registered",
      "activeJobs": "Active Jobs",
      "revenueMTD": "Revenue (MTD)",
      "avgJobValue": "Avg. Job Value",
      "jobsThisWeek": "Jobs This Week"
    },
    "kpis": {
      "grossProfit": "Gross Profit/Job",
      "monthlyRevenue": "Monthly Revenue",
      "avgLeadTime": "Avg Lead Time",
      "churnRate": "Churn Rate",
      "avgOrderValue": "Average Order Value",
      "dso": "DSO",
      "firstTimeFix": "First-Time Fix Rate",
      "vsLastMonth": "vs last month",
      "bookingToCompletion": "booking to completion",
      "twelveMonthInactive": "12-month inactive",
      "inclUpsells": "incl. upsells",
      "daysSalesOutstanding": "days sales outstanding",
      "noRepeatVisits": "no repeat visits",
      "totalRevenue": "Total Revenue",
      "laborPartsCombined": "Labor + Parts combined",
      "grossProfitMargin": "Gross Profit Margin",
      "afterPartCosts": "After part costs",
      "revenuePerInvoice": "Revenue per invoice",
      "efficiencyRate": "Efficiency Rate",
      "billableVsClocked": "Billable vs clocked hours",
      "workInProgress": "WORK-IN-PROGRESS (WIP)",
      "openJobsNotInvoiced": "Open jobs not yet invoiced",
      "quoteConversion": "QUOTE CONVERSION",
      "quotesToWorkOrders": "Quotes converted to Work Orders",
      "checkInToCompletion": "From check-in to completion",
      "days": "days",
      "totalBookings": "Total Bookings",
      "thisMonth": "This month",
      "totalEmployees": "Total Employees",
      "activeStaff": "Active staff members",
      "totalServices": "Total Services",
      "catalogServices": "Services in catalog"
    },
    "filters": {
      "today": "Today",
      "thisWeek": "This Week",
      "thisMonth": "This Month",
      "thisQuarter": "This Quarter",
      "thisYear": "This Year",
      "allMechanics": "All Mechanics"
    },
    "workshopStatus": {
      "title": "STATUS",
      "carsIn": "Cars In"
    },
    "charts": {
      "revenueOverview": "Revenue Overview",
      "totalRevenue": "Total Revenue",
      "labor": "Labor",
      "serviceBreakdown": "Service Breakdown",
      "weeklyEfficiency": "Weekly Efficiency",
      "billableHours": "Billable Hours",
      "totalHours": "Total Hours"
    },
    "lowInventory": "Low Inventory Alert",
    "itemsLow": "items low",
    "viewAllProducts": "View All Products",
    "todaysServices": "Today's Services",
    "scheduled": "scheduled",
    "viewSchedule": "View Schedule",
    "checkInList": "Check-in List",
    "actions": {
      "newCustomer": "New Customer",
      "addVehicle": "Add Vehicle",
      "createJob": "Create Job",
      "newService": "New Service"
    }
  },
  "customers": {
    "title": "Customers",
    "description": "Manage your customer database",
    "addCustomer": "Add Customer",
    "addCustomerDesc": "Add a new customer to your database",
    "addCompany": "Add Company",
    "addCompanyDesc": "Add a new company to your database",
    "namePlaceholder": "Enter customer name",
    "emailPlaceholder": "Enter email address",
    "phonePlaceholder": "Enter phone number",
    "customerAdded": "Customer added successfully",
    "searchPlaceholder": "Search customers...",
    "customer": "Customer",
    "vehicles": "Vehicles",
    "totalSpent": "Total Spent",
    "lastVisit": "Last Visit",
    "emptyMessage": "No customers found",
    "tabs": {
      "customers": "Customers",
      "companies": "Companies"
    },
    "companies": {
      "title": "Companies",
      "name": "Company Name",
      "orgNumber": "Org. Number",
      "contact": "Contact",
      "location": "Location",
      "city": "City",
      "driversCount": "Drivers",
      "drivers": "drivers",
      "searchPlaceholder": "Search companies...",
      "emptyMessage": "No companies found",
      "addCompany": "Add Company"
    },
    "form": {
      "companyInfo": "Company Information",
      "companyInfoDesc": "Enter the company details if the customer is a business",
      "personalInfo": "Personal Information",
      "personalInfoDesc": "Enter the customer's personal details",
      "orgNumber": "Organization Number",
      "companyName": "Company Name",
      "companyNamePlaceholder": "Enter company name",
      "reference": "Reference",
      "referencePlaceholder": "Enter reference",
      "address": "Address",
      "addressPlaceholder": "Enter address",
      "zipCode": "Zip Code",
      "city": "City",
      "country": "Country",
      "driverInfo": "Driver Information",
      "driverInfoDesc": "Enter the primary contact/driver details",
      "firstName": "First Name",
      "firstNamePlaceholder": "Enter first name",
      "lastName": "Last Name",
      "lastNamePlaceholder": "Enter last name",
      "externalNumber": "External Number",
      "externalNumberPlaceholder": "Enter external reference number",
      "hasCard": "Has Customer Card",
      "hasCardDesc": "Check if the customer has a loyalty/membership card",
      "cardNumber": "Card Number",
      "cardValidTo": "Valid Until",
      "keyNumber": "Key Number",
      "cardKeyInfo": "Card & Key Information",
      "consents": "Consents & Preferences",
      "gdprAccept": "GDPR Consent",
      "gdprAcceptDesc": "Customer has accepted data processing terms",
      "warrantyDriver": "Warranty Driver",
      "warrantyDriverDesc": "Customer is registered as a warranty driver",
      "acceptsMarketing": "Marketing Consent",
      "acceptsMarketingDesc": "Customer accepts marketing communications",
      "sharedNotes": "Shared Notes",
      "sharedNotesPlaceholder": "Notes visible to all staff...",
      "sharedNotesDesc": "These notes will be visible to all staff members",
      "internalNotes": "Internal Notes",
      "internalNotesPlaceholder": "Private notes...",
      "internalNotesDesc": "These notes are only visible to management",
      "notesTitle": "Notes",
      "belongsToCompany": "Belongs to a Company",
      "belongsToCompanyDesc": "Check if this customer is associated with a company",
      "searchCompanyPlaceholder": "Search by company name or org number...",
      "noCompaniesFound": "No matching companies found",
      "createNewCompany": "Create New Company",
      "linked": "Linked",
      "hasVehicles": "Has Vehicles",
      "hasVehiclesDesc": "Link one or more vehicles to this customer",
      "searchVehiclePlaceholder": "Search by registration number...",
      "noVehiclesFound": "No matching vehicles found",
      "createNewVehicle": "Create New Vehicle",
      "noCustomersFound": "No customers found.",
      "firstNameRequired": "First name is required",
      "lastNameRequired": "Last name is required",
      "invalidEmail": "Invalid email address",
      "phoneRequired": "Phone number is required",
      "clearSelection": "Clear selection",
      "cityPlaceholder": "Stockholm",
      "countryPlaceholder": "Sweden",
      "cardNumberPlaceholder": "XXXX-XXXX-XXXX",
      "keyNumberPlaceholder": "KEY-001",
      "emailFormatPlaceholder": "user@example.com",
      "companyEmailFormatPlaceholder": "company@example.com",
      "orgNumberRequired": "Organization number is required",
      "companyNameRequired": "Company name is required",
      "invalidPhoneFormat": "Invalid phone number format",
      "firstNameTooLong": "First name must be at most 128 characters",
      "lastNameTooLong": "Last name must be at most 128 characters",
      "addressRequired": "Address is required",
      "addressTooLong": "Address must be at most 255 characters",
      "zipCodeRequired": "Zip code is required",
      "zipCodeTooLong": "Zip code must be at most 16 characters",
      "cityRequired": "City is required",
      "cityTooLong": "City must be at most 255 characters",
      "countryRequired": "Country is required",
      "countryTooLong": "Country must be at most 255 characters",
      "orgNumberTooLong": "Organization number must be at most 11 characters",
      "externalNumberTooLong": "External number must be at most 255 characters"
    },
    "deleteConfirm": "Are you sure you want to delete {{name}}? This cannot be undone.",
    "customerUpdated": "Customer updated",
    "jobHistory": "Job History",
    "memberSince": "Member Since"
  },
  "vehicles": {
    "title": "Vehicles",
    "description": "Manage registered vehicles",
    "addVehicle": "Add Vehicle",
    "addVehicleDesc": "Add a new vehicle to your registry",
    "updateVehicle": "Update Vehicle",
    "updateVehicleDesc": "Modify existing vehicle information",
    "vehicleAdded": "Vehicle added successfully",
    "vehicleUpdated": "Vehicle updated successfully",
    "vehicleFound": "Vehicle found - form populated with existing data",
    "searchPlaceholder": "Search vehicles...",
    "vehicle": "Vehicle",
    "licensePlate": "License Plate",
    "owner": "Owner",
    "mileage": "Mileage",
    "lastService": "Last Service",
    "emptyMessage": "No vehicles found",
    "allLoaded": "All vehicles loaded",
    "vehicleDeleted": "Vehicle deleted successfully",
    "deleteConfirmTitle": "Delete Vehicle",
    "deleteConfirmDesc": "This will soft-delete the vehicle. It can be restored later if needed. Are you sure?",
    "model": "Model",
    "year": "Year",
    "form": {
      "registrationSearch": "Registration Number",
      "registrationSearchDesc": "Enter the vehicle registration number to search for existing records",
      "vehicleFoundWillUpdate": "Vehicle found in system - form will update existing record",
      "noVehicleFoundWillCreate": "No vehicle found - a new record will be created",
      "tempRegNumber": "Temporary Registration",
      "tempRegNumberDesc": "Check if this is a temporary registration number",
      "vehicleDetails": "Vehicle Details",
      "vehicleDetailsDesc": "Basic information about the vehicle",
      "brand": "Brand",
      "model": "Model",
      "year": "Year",
      "color": "Color",
      "horsePower": "Horse Power",
      "mileage": "Mileage (km)",
      "technicalDetails": "Technical Details",
      "technicalDetailsDesc": "Engine and transmission specifications",
      "fuelType": "Fuel Type",
      "gearType": "Transmission",
      "carType": "Car Type",
      "registrationDate": "Registration Date",
      "additionalInfo": "Owner & Additional Information",
      "owner": "Vehicle Owner",
      "ownerSearchDesc": "Search and link an owner to this vehicle",
      "ownerSearchPlaceholder": "Search by name, email or phone...",
      "ownerLinked": "Linked",
      "noOwnersFound": "No matching owners found",
      "createNewOwner": "Create New Owner",
      "carID": "Car ID",
      "carIDPlaceholder": "Enter car identifier",
      "notes": "Notes",
      "notesPlaceholder": "Any additional notes about this vehicle...",
      "immutableHint": "This field cannot be changed after creation",
      "engineSpecifications": "Engine Specifications",
      "status": "Status",
      "fuelTypeOptions": {
        "Diesel": "Diesel",
        "Gasoline": "Gasoline",
        "Electric": "Electric",
        "Hybrid": "Hybrid",
        "Hydrogen": "Hydrogen"
      },
      "gearTypeOptions": {
        "Manual": "Manual",
        "Automatic": "Automatic"
      },
      "carTypeOptions": {
        "Sedan": "Sedan",
        "SUV": "SUV",
        "Truck": "Truck",
        "Coupe": "Coupe",
        "Convertible": "Convertible"
      },
      "brandPlaceholder": "Toyota",
      "modelPlaceholder": "Camry",
      "registrationRequired": "Registration number is required",
      "registrationTooShort": "Registration number must be at least 3 characters",
      "registrationTooLong": "Registration number must be at most 11 characters",
      "brandTooLong": "Brand must be at most 128 characters",
      "modelTooLong": "Model must be at most 128 characters",
      "colorTooLong": "Color must be at most 64 characters",
      "fuelTypeTooLong": "Fuel type must be at most 64 characters",
      "gearTypeTooLong": "Transmission must be at most 64 characters",
      "carTypeTooLong": "Car type must be at most 64 characters",
      "yearMustBeNumber": "Year must be a number",
      "yearAfter1901": "Year must be after 1901",
      "yearNotGreaterThan": "Year cannot be greater than {{year}}",
      "horsePowerMustBeInteger": "Horse power must be a whole number",
      "horsePowerNegative": "Horse power cannot be negative",
      "horsePowerTooLarge": "Horse power too large",
      "mileageMustBeInteger": "Mileage must be a whole number",
      "mileageNegative": "Mileage cannot be negative",
      "mileageTooLarge": "Mileage too large",
      "regDateFuture": "Registration date cannot be in the future",
      "colorOptions": {
        "LightBlue": "Light Blue",
        "Blue": "Blue",
        "DarkBlue": "Dark Blue",
        "LightGreen": "Light Green",
        "Green": "Green",
        "DarkGreen": "Dark Green",
        "LightYellow": "Light Yellow",
        "Yellow": "Yellow",
        "DarkYellow": "Dark Yellow",
        "LightPurple": "Light Purple",
        "Purple": "Purple",
        "DarkPurple": "Dark Purple",
        "LightPink": "Light Pink",
        "Pink": "Pink",
        "DarkPink": "Dark Pink",
        "LightTurquoise": "Light Turquoise",
        "Turquoise": "Turquoise",
        "DarkTurquoise": "Dark Turquoise",
        "Orange": "Orange",
        "Red": "Red",
        "None": "None"
      }
    },
    "editVehicle": "Edit Vehicle",
    "lockFields": "Lock Fields",
    "readOnlyHint": "Click 'Edit Vehicle' to unlock fields for editing. Some fields cannot be changed after creation.",
    "blacklist": "Blacklist",
    "removeBlacklist": "Remove Blacklist",
    "blacklisted": "Vehicle has been blacklisted",
    "unblacklisted": "Vehicle has been removed from blacklist",
    "blacklistedBadge": "Blacklisted",
    "deleteConfirm": "Are you sure you want to delete {{name}}? This cannot be undone.",
    "filters": {
      "fuelPetrol": "Petrol",
      "fuelDiesel": "Diesel",
      "fuelElectric": "Electric",
      "fuelHybrid": "Hybrid",
      "typeSedan": "Sedan",
      "typeSuv": "SUV",
      "typeHatchback": "Hatchback"
    }
  },
  "services": {
    "title": "Services",
    "description": "Manage your service catalog and pricing",
    "addService": "Add Service",
    "addServiceDesc": "Create a new service for your catalog",
    "searchPlaceholder": "Search services...",
    "popular": "Popular",
    "categoryFilter": "Filter by category",
    "duration": "Duration (min)",
    "serviceImage": "Service Image",
    "namePlaceholder": "e.g. Oil Change",
    "descriptionPlaceholder": "Brief description of the service",
    "serviceAdded": "Service added successfully",
    "categories": {
      "all": "All",
      "maintenance": "Maintenance",
      "safety": "Safety",
      "diagnostics": "Diagnostics",
      "comfort": "Comfort"
    },
    "form": {
      "basicInfo": "Basic Information",
      "basicInfoDesc": "Add basic information for the new service.",
      "pricingDuration": "Pricing & Duration",
      "pricingDurationDesc": "Add price and time information for the new service.",
      "options": "Additional Options",
      "status": "Status",
      "color": "Color",
      "award": "Bonus / Award",
      "itemNumber": "Item Number",
      "suppliersArticleNumber": "Supplier's Article Number",
      "externalArticleNumber": "External Article Number",
      "includeInAutomaticSms": "Include in Automatic SMS",
      "hidden": "Hidden",
      "warrantyCard": "Warranty Card",
      "blacklisted": "Blacklisted",
      "validation": {
        "nameRequired": "Service name is required",
        "costNonNegative": "Cost must be non-negative",
        "costMustBeInteger": "Cost must be a whole number",
        "categoryRequired": "Category is required",
        "callIntervalMustBeInteger": "Duration must be a whole number",
        "callIntervalRange": "Duration must be between 1 and 36"
      }
    },
    "deleted": "Service deleted",
    "emptyMessage": "No services found",
    "selectCategory": "Select category",
    "service": "Service",
    "serviceUpdated": "Service updated successfully"
  },
  "jobs": {
    "title": "Jobs",
    "description": "Manage work orders and service jobs",
    "createJob": "Create Job",
    "createJobDesc": "Create a new work order",
    "selectCustomer": "Select a customer",
    "selectTechnician": "Select a technician",
    "jobCreated": "Job created successfully",
    "jobUpdated": "Job updated successfully",
    "deleted": "Job deleted successfully",
    "deleteConfirm": "Are you sure you want to delete job {{name}}? This cannot be undone.",
    "searchPlaceholder": "Search jobs...",
    "jobId": "Job ID",
    "customerVehicle": "Customer & Vehicle",
    "assignedTo": "Assigned To",
    "scheduled": "Scheduled",
    "total": "Total",
    "unassigned": "Unassigned",
    "emptyMessage": "No jobs found",
    "estimatedTime": "Est. Time",
    "details": "Job Details",
    "notes": "Notes",
    "status": "Status",
    "statusFilters": {
      "all": "All",
      "pending": "Pending",
      "inProgress": "In Progress",
      "completed": "Completed",
      "cancelled": "Cancelled",
      "preliminary": "Preliminary",
      "created": "Created",
      "inShop": "In Shop",
      "startService": "In Service",
      "started": "Started",
      "pickedUp": "Picked Up",
      "pickup": "Picked Up",
      "archived": "Archived",
      "finished": "Finished"
    },
    "orderID": "Order ID",
    "orderNumber": "Order #",
    "technician": "Technician",
    "dropOff": "Drop-off",
    "plannedPickup": "Planned Pickup",
    "actualDropOff": "Actual Drop-off",
    "actualPickup": "Actual Pickup",
    "billed": "Billed",
    "notBilled": "Not Billed",
    "workSchedule": "Work Schedule",
    "vatFree": "VAT Free",
    "kanbanStatus": "Kanban Status",
    "serviceNotes": "Service Notes",
    "productNotes": "Product Notes"
  },
  "pricing": {
    "title": "Pricing",
    "description": "Manage service pricing and profit margins",
    "addPricing": "Add Pricing",
    "searchPlaceholder": "Search services...",
    "service": "Service",
    "category": "Category",
    "laborRate": "Labor Rate",
    "partsCost": "Parts Cost",
    "basePrice": "Base Price",
    "margin": "Margin",
    "totalServicesValue": "Total Services Value",
    "avgProfitMargin": "Avg. Profit Margin",
    "activePricingItems": "Active Pricing Items"
  },
  "roles": {
    "title": "Roles & Permissions",
    "description": "Manage user roles, access control, and work timings",
    "createRole": "Create Role",
    "createRoleDesc": "Define a new role with a name and description",
    "deleteRole": "Delete Role",
    "deleteRoleConfirm": "Are you sure you want to delete the role \"{{name}}\"? This action cannot be undone.",
    "roleCreated": "Role created successfully",
    "roleUpdated": "Role updated successfully",
    "roleDeleted": "Role deleted successfully",
    "roleName": "Role Name",
    "roleNamePlaceholder": "e.g. Supervisor",
    "roleDescription": "Description",
    "roleDescPlaceholder": "Describe what this role can do...",
    "roleColor": "Color",
    "colorRed": "Red",
    "colorBlue": "Blue",
    "colorGreen": "Green",
    "colorGray": "Gray",
    "addPermission": "Add Permission",
    "addPermissionDesc": "Create a new permission with a key, display name, and description",
    "editPermission": "Edit Permission",
    "editPermissionDesc": "Update the permission name and description",
    "deletePermission": "Delete Permission",
    "deletePermissionConfirm": "Are you sure you want to delete the permission \"{{name}}\"? This action cannot be undone.",
    "permissionCreated": "Permission created successfully",
    "permissionUpdated": "Permission updated successfully",
    "permissionDeleted": "Permission deleted successfully",
    "permissionKey": "Permission Key",
    "permissionKeyPlaceholder": "e.g. customer:view",
    "permissionName": "Display Name",
    "permissionNamePlaceholder": "e.g. Export Data",
    "permissionDescription": "Description",
    "permissionDescPlaceholder": "Describe what this permission allows...",
    "admin": "Administrator",
    "user": "User",
    "moderator": "Moderator",
    "manager": "Manager",
    "technician": "Technician",
    "receptionist": "Receptionist",
    "permissions": "Permissions",
    "manageRoles": "Manage Roles",
    "users": "users",
    "rolesLabel": "Roles",
    "enabled": "enabled",
    "noPermissionsFound": "No permissions found",
    "noRolesFound": "No roles found",
    "searchPermissionsPlaceholder": "Search permissions...",
    "noPermissionsMatchSearch": "No permissions match your search",
    "workTimings": {
      "title": "Work Timings",
      "description": "Configure special work schedules for this role",
      "defaultSchedule": "Default Schedule",
      "customSchedule": "Custom Schedule",
      "useCustomSchedule": "Use Custom Schedule",
      "useCustomScheduleDesc": "Enable to set custom work hours for this role",
      "workDays": "Work Days",
      "shiftStart": "Shift Start",
      "shiftEnd": "Shift End",
      "breakDuration": "Break Duration (min)",
      "breakDurationDesc": "Duration of break in minutes (0-120)",
      "overtime": "Overtime Allowed",
      "overtimeAllowed": "Overtime Allowed",
      "overtimeAllowedDesc": "Allow employees with this role to work overtime",
      "maxOvertimeHours": "Max Overtime Hours/Week",
      "maxOvertimeHoursDesc": "Maximum overtime hours allowed per week (0-40)"
    },
    "dashboard": {
      "title": "Dashboard",
      "configureInfo": "Configure which dashboard cards appear on the homepage for users with this role.",
      "usersCanCustomize": "Users can customize their own layout later.",
      "availableModules": "Available Dashboard Modules",
      "selectUpTo4": "Select up to 4",
      "dashboardOrder": "Dashboard Order",
      "dragToReorder": "Drag to reorder how cards appear on the homepage",
      "selected": "Selected",
      "select": "Select",
      "maxModules": "You can select up to 4 modules",
      "modules": {
        "mySchedule": "My Schedule",
        "myScheduleDesc": "Mini-Calendar",
        "overdueTasks": "Overdue Tasks & Activities",
        "overdueTasksDesc": "Task Management",
        "salesPipeline": "Sales Pipeline Summary",
        "salesPipelineDesc": "CRM/Pipelines",
        "outstandingInvoices": "Outstanding Invoices & A/R",
        "outstandingInvoicesDesc": "Finance & Billing",
        "lowStock": "Low Stock Alerts & Reorder",
        "lowStockDesc": "Inventory Management",
        "absenceRequests": "Absence & Vacation Requests",
        "absenceRequestsDesc": "HR Management",
        "marketingPerformance": "Marketing/SEO Performance",
        "marketingPerformanceDesc": "Marketing Analytics",
        "teamEfficiency": "Team WO Efficiency",
        "teamEfficiencyDesc": "Work Orders Analytics"
      },
      "preview": {
        "appointmentsToday": "{{count}} appointments today",
        "overdueCount": "{{count}} overdue",
        "followUpClient": "Follow up client",
        "sendProposal": "Send proposal",
        "pipelineValue": "Pipeline Value",
        "outstanding": "Outstanding",
        "overdue": "Overdue",
        "lowStockCount": "{{count}} low stock",
        "screwsExample": "Screws M8x40",
        "screwsQty": "12 pcs",
        "cableExample": "Cable 2x2.5",
        "cableQty": "5m",
        "absenceExample1": "Anna S. - Vacation",
        "review": "Review",
        "absenceExample2": "Erik L. - Sick",
        "newLeads": "New Leads",
        "traffic": "Traffic",
        "avgTime": "Avg. Time"
      }
    }
  },
  "settings": {
    "title": "Settings",
    "description": "Manage your system preferences and configurations",
    "saveChanges": "Save Changes",
    "tabs": {
      "branchInfo": "Branch Info",
      "workingHours": "Store Opening Hours",
      "staff": "Staff",
      "permissions": "Permissions",
      "integrations": "Integrations",
      "weeklyNotes": "Weekly Notes",
      "stores": "Stores",
      "qualifications": "Qualifications",
      "unionAgreements": "Union Agreements",
      "categories": "Categories",
      "communication": "Communication",
      "services": "Services",
      "packages": "Packages",
      "absenceTypes": "Absence Types"
    },
    "stores": {
      "title": "Stores",
      "description": "Manage all stores in your organization",
      "newStore": "New Store",
      "newStoreDesc": "Add a new store location to your organization",
      "storesCount": "stores",
      "storeName": "Store Name",
      "storeNamePlaceholder": "e.g. Main Branch",
      "location": "Location",
      "manager": "Manager",
      "managerPlaceholder": "e.g. Erik Andersson",
      "capacity": "Capacity",
      "lifts": "lifts",
      "bays": "bays",
      "noStores": "No stores found",
      "storeInfo": "Store Information",
      "contactAddress": "Contact & Address",
      "address": "Address",
      "addressPlaceholder": "e.g. Industrial Road 12",
      "city": "City",
      "cityPlaceholder": "e.g. Stockholm",
      "zipCode": "Zip Code",
      "zipCodePlaceholder": "e.g. 111 22",
      "workshopCapacity": "Workshop Capacity",
      "additionalNotes": "Additional Notes",
      "notesPlaceholder": "Any additional notes about this store...",
      "createStore": "Create Store",
      "fillRequired": "Please fill in all required fields",
      "storeCreated": "Store created successfully",
      "storeUpdated": "Store updated successfully",
      "storeDetailsDesc": "View and edit store details",
      "basicInfo": "Basic Information",
      "basicInfoDesc": "General details and identity of the store",
      "website": "Website",
      "storeDescription": "Store Description",
      "contactPerson": "Contact Person",
      "currency": "Currency",
      "storeStatus": "Store Active",
      "businessInfo": "Business Information",
      "businessInfoDesc": "Tax and organization identifiers",
      "vatNumber": "VAT Number",
      "orgNumber": "Organization Number",
      "maxUsers": "Max Users",
      "contact": "Contact Information",
      "contactDesc": "Phone and email for this store",
      "email": "Email Address",
      "phone": "Phone Number",
      "addressinfo": "Full Address",
      "addressDesc": "Physical location of the store",
      "country": "Country",
      "features": "Features",
      "featuresDesc": "Enable or disable capabilities for this store",
      "fSkatt": "F-Tax (F-Skatt)",
      "allowCarAPI": "Allow Car API",
      "allowSendSMS": "Allow Sending SMS",
      "sendSMS": "Send SMS",
      "usesCheckin": "Uses Check-in",
      "usesPIN": "Uses PIN",
      "payment": "Payment Options",
      "paymentDesc": "Configure payment identifiers and terms",
      "bankgiro": "Bankgiro",
      "plusgiro": "Plusgiro",
      "paymentDays": "Payment Days",
      "paymentDaysMustBeInteger": "Payment days must be a whole number",
      "deleteConfirm": "Are you sure you want to delete {{name}}? This cannot be undone.",
      "storeDetails": "Store Details",
      "storeNameRequired": "Store name required",
      "invalidEmail": "Invalid email address",
      "websitePlaceholder": "https://example.com",
      "vatNumberPlaceholder": "SE556000000001",
      "emailPlaceholder": "store@example.com",
      "countryPlaceholder": "Sweden",
      "vatNumberTooLong": "VAT number must be at most 32 characters",
      "orgNumberRequired": "Organization number must be between 8 and 11 characters",
      "orgNumberTooLong": "Organization number must be at most 11 characters",
      "phoneRequired": "Phone number is required",
      "invalidPhoneFormat": "Invalid phone number format",
      "addressRequired": "Address is required",
      "zipCodeRequired": "Zip code must be at least 3 characters",
      "zipCodeTooLong": "Zip code must be at most 16 characters",
      "cityRequired": "City is required",
      "countryRequired": "Country is required",
      "reminderFee": "Default reminder fee",
      "reminderFeeHint": "Prefilled when creating reminder invoices (påminnelseavgift)."
    },
    "users": {
      "title": "User Management",
      "description": "Manage users and their access to the organization",
      "totalUsers": "{{count}} users in organization",
      "addStaff": "Add Staff Member",
      "addStaffDesc": "Create a staff account with immediate access to your organization",
      "createAccount": "Create Account",
      "staffCreated": "Staff member account created successfully",
      "inviteByEmail": "Invite by Email",
      "inviteByEmailDesc": "Send an email invitation so someone can join your organization with their own account",
      "inviteSentSuccessfully": "Invitation sent successfully",
      "pendingInvites": "Pending Invites",
      "pendingInvitesEmpty": "No pending invites",
      "cancelInvite": "Cancel Invite",
      "cancelInviteConfirm": "Are you sure you want to cancel the invite for {{email}}? This cannot be undone.",
      "inviteCancelled": "Invite cancelled",
      "invitedOn": "Invited On",
      "namePlaceholder": "Enter user's name",
      "emailPlaceholder": "Enter user's email",
      "role": "Role",
      "userRemoved": "User removed successfully",
      "fillAllFields": "Please fill in all required fields",
      "noUsers": "No users found",
      "employeeDetails": "Employee Details",
      "shortUserName": "Short Username",
      "signature": "Signature",
      "employmentNumber": "Employment Number",
      "personalNumber": "Personal Number",
      "pin": "PIN",
      "comment": "Comment",
      "stores": "Assigned Stores",
      "overview": "Account Overview",
      "userStatus": "Account Status",
      "employeeStatus": "Employee Status",
      "noRole": "No role assigned",
      "noStores": "No stores assigned",
      "hr": {
        "title": "HR & Compensation",
        "section": "HR Profile",
        "hourlyRate": "Hourly Rate",
        "baseSalary": "Base Salary",
        "commissionPct": "Commission %",
        "mileageRate": "Mileage Rate",
        "currency": "Currency",
        "hoursPerWeek": "Hours/Week",
        "leaveBalances": "Leave Balances (days/year)",
        "vacation": "Vacation",
        "sick": "Sick",
        "vab": "VAB",
        "parental": "Parental",
        "rate": "Rate",
        "salary": "Monthly",
        "remaining": "Remaining",
        "saved": "HR profile updated",
        "edit": "Edit HR profile"
      },
      "deleteConfirm": "Are you sure you want to delete {{name}}? This cannot be undone.",
      "username": "Username",
      "required": "Required",
      "invalidEmail": "Invalid email address",
      "minPasswordLength": "Must be at least 6 characters",
      "shortUserNamePlaceholder": "ABCD",
      "currencyPlaceholder": "CCY",
      "employmentNumberTooLong": "Employment number must be at most 128 characters",
      "personalNumberTooLong": "Personal number must be at most 16 characters",
      "signatureTooLong": "Signature must be at most 4 characters",
      "pinExactLength": "PIN must be exactly 4 characters"
    },
    "businessInfo": {
      "title": "Business Information",
      "description": "Manage your business details and contact information",
      "businessName": "Business Name",
      "companyInfo": "Company Information",
      "companyName": "Company Name",
      "orgNumber": "Organization Number",
      "vatNumber": "VAT Number",
      "phone": "Phone Number",
      "email": "Email Address",
      "address": "Address",
      "workshopDetails": "Workshop Details",
      "numberOfLifts": "Number of Lifts",
      "numberOfBays": "Number of Bays"
    },
    "workingHours": {
      "title": "Business Operating Hours",
      "description": "Set your workshop operating hours",
      "monday": "Monday",
      "tuesday": "Tuesday",
      "wednesday": "Wednesday",
      "thursday": "Thursday",
      "friday": "Friday",
      "saturday": "Saturday",
      "sunday": "Sunday",
      "to": "to",
      "applyToAll": "Apply to all",
      "appliedToAll": "Monday hours applied to all days",
      "specialHours": "Special Working Hours",
      "addSpecialHour": "Add Special Hours",
      "noSpecialHours": "No special working hours configured",
      "specialName": "e.g. Christmas Eve, Midsummer...",
      "saved": "Working hours saved",
      "closed": "Closed"
    },
    "notifications": {
      "title": "Notifications",
      "description": "Configure how you receive notifications",
      "emailNotifications": "Email Notifications",
      "emailNotificationsDesc": "Receive email updates for new jobs and customers",
      "jobCompletionAlerts": "Job Completion Alerts",
      "jobCompletionAlertsDesc": "Get notified when a job is completed",
      "dailySummary": "Daily Summary",
      "dailySummaryDesc": "Receive a daily summary of activities"
    },
    "emailTemplates": {
      "title": "Email Templates",
      "description": "Customize email templates for customer communications",
      "jobConfirmation": "Job Confirmation",
      "jobConfirmationDesc": "Sent when a new job is created",
      "jobCompletion": "Job Completion",
      "jobCompletionDesc": "Sent when a job is completed",
      "invoice": "Invoice",
      "invoiceDesc": "Sent with the invoice after payment"
    },
    "security": {
      "title": "Security",
      "description": "Manage security settings and access controls",
      "twoFactor": "Two-Factor Authentication",
      "twoFactorDesc": "Add an extra layer of security",
      "sessionTimeout": "Session Timeout",
      "sessionTimeoutDesc": "Auto logout after 30 minutes of inactivity",
      "changePassword": "Change Password"
    },
    "dataBackup": {
      "title": "Data & Backup",
      "description": "Manage your data and backup settings",
      "autoBackup": "Auto Backup",
      "autoBackupDesc": "Automatically backup data daily",
      "exportData": "Export Data",
      "importData": "Import Data"
    },
    "branchInfoAccessDenied": "You don't have access to view this store's information",
    "headers": {
      "branchInfo": {
        "title": "Branch Info",
        "description": "Manage your business details and contact information."
      },
      "workingHours": {
        "title": "Store Opening Hours",
        "description": "Set your workshop operating hours and special days."
      },
      "staff": {
        "title": "Staff",
        "description": "Manage employees, roles, compensation and leave balances."
      },
      "permissions": {
        "title": "Roles & Permissions",
        "description": "Define organization roles and access permissions."
      },
      "stores": {
        "title": "Stores",
        "description": "Manage all stores in your organization."
      },
      "qualifications": {
        "title": "Qualifications",
        "description": "Track staff certifications and skills."
      },
      "unionAgreements": {
        "title": "Union Agreements",
        "description": "Manage collective union agreements applied to employees."
      },
      "weeklyNotes": {
        "title": "Weekly Notes",
        "description": "Add daily and weekly notes shown on the dashboard."
      },
      "integrations": {
        "title": "Integrations",
        "description": "Connect third-party services to your workshop."
      },
      "categories": {
        "title": "Categories",
        "description": "Organize services and products into categories."
      },
      "services": {
        "title": "Services",
        "description": "Manage the services offered by your workshop."
      },
      "communication": {
        "title": "Communication",
        "description": "Customize email and SMS templates sent to customers."
      }
    },
    "storeCreated": "Store created successfully",
    "weeklyNotes": {
      "title": "Weekly Notes",
      "description": "Manage weekly summaries and daily notes for your team",
      "dailyNotes": "Daily Notes",
      "noteSaved": "Note saved",
      "noteDeleted": "Note deleted",
      "summarySaved": "Weekly summary saved",
      "noteSaveFailed": "Failed to save the note. Please try again.",
      "noteDeleteFailed": "Failed to delete the note. Please try again.",
      "summarySaveFailed": "Failed to save the weekly summary. Please try again."
    }
  },
  "booking": {
    "title": "Booking",
    "description": "Manage appointments and service bookings",
    "progressLabel": "Booking progress",
    "weeklyOverview": "Weekly Overview",
    "bookings": "bookings",
    "steps": {
      "date": "Date",
      "selection": "Selection",
      "services": "Services",
      "checkout": "Checkout",
      "customer": "Customer",
      "vehicle": "Vehicle",
      "schedule": "Schedule",
      "rentCars": "Rent Cars",
      "vehicleImages": "Vehicle Images",
      "confirm": "Confirm"
    },
    "vehicleImages": {
      "title": "Vehicle Images",
      "description": "Upload photos of the vehicle from different angles. This step is optional.",
      "optional": "Optional",
      "upload": "Upload",
      "files": "files",
      "emptyHint": "No images added yet",
      "permissionDenied": "Camera permission denied. Please allow camera access to add photos.",
      "captureFailed": "Couldn't capture the photo. Please try again.",
      "categories": {
        "front": "Front",
        "left": "Left Side",
        "right": "Right Side",
        "rear": "Rear",
        "interior": "Interior",
        "tyres": "Tyres",
        "damage": "Damage (please highlight)"
      }
    },
    "selectDate": "Select Date",
    "selectDateDesc": "Choose a date for the appointment from the calendar above",
    "changeDate": "Change Date",
    "clickCalendarToSelect": "Click a date on the calendar above to select",
    "date": "Date",
    "selectCustomerVehicle": "Select Customer & Vehicle",
    "selectCustomerVehicleDesc": "Choose by customer or vehicle",
    "byCustomer": "By Customer",
    "byVehicle": "By Vehicle",
    "assignEmployee": "Assign employee",
    "assignEngineers": "Assign Engineers",
    "assignEngineersDesc": "Select engineers for {{service}}",
    "selectEngineers": "Select engineers",
    "selectCustomer": "Select Customer",
    "selectCustomerDesc": "Choose an existing customer or create a new one",
    "searchCustomers": "Search customers by name, email, or phone...",
    "customerList": "Customer list",
    "selectVehicle": "Select Vehicle",
    "selectVehicleDesc": "Choose the vehicle for this service",
    "searchVehicles": "Search vehicles by make, model, or license plate...",
    "vehicleList": "Vehicle list",
    "selectServices": "Select Services",
    "selectServicesDesc": "Add services to this booking",
    "searchServices": "Search services...",
    "filterByCategory": "Filter by category",
    "serviceList": "Available services",
    "checkout": "Checkout & Schedule",
    "checkoutDesc": "Review and finalize the booking",
    "scheduledDate": "Scheduled Date",
    "scheduledTime": "Scheduled Time",
    "notes": "Notes",
    "notesPlaceholder": "Add any special instructions or notes...",
    "createJob": "Create Job",
    "jobCreated": "Job created successfully!",
    "summary": "Booking Summary",
    "customer": "Customer",
    "vehicle": "Vehicle",
    "selectedServices": "Selected Services",
    "estimatedDuration": "Estimated Duration",
    "estimatedTime": "Estimated Time",
    "total": "Total",
    "subtotal": "Subtotal",
    "vat": "VAT",
    "vatFree": "VAT Free",
    "discount": "Discount",
    "discountPercent": "Percentage",
    "discountFixed": "Fixed amount",
    "preliminary": "Preliminary Booking",
    "preliminaryDesc": "Mark this as a tentative booking that needs confirmation",
    "emptySummary": "Start by selecting a customer",
    "quantity": "Quantity",
    "increaseQuantity": "Increase quantity",
    "decreaseQuantity": "Decrease quantity",
    "advancedOptions": "Advanced",
    "advancedMode": "Advanced Mode",
    "autoAssign": "Auto-assign",
    "reviewBooking": "Review Your Booking",
    "reviewDescription": "Please verify all details before confirming",
    "customerVehicle": "Customer & Vehicle",
    "scheduleDetails": "Schedule Details",
    "intakeTime": "Car Intake Time",
    "intakeTimeDesc": "When the customer will drop off the vehicle",
    "deliveryTime": "Delivery Time (Post Work)",
    "deliveryTimeDesc": "When the vehicle will be ready for pickup",
    "intake": "Intake",
    "delivery": "Delivery",
    "loanCar": "Loan Car",
    "selectLoanCar": "Select an available loan car",
    "needsLoanCar": "Customer needs a loan car",
    "addNewCustomer": "Add New Customer",
    "addNewVehicle": "Add New Vehicle",
    "noResultsFor": "No results found for \"{{search}}\"",
    "noCustomersFound": "No customers found. Add a new one.",
    "noVehiclesFound": "No vehicles found. Add a new one.",
    "employeeOnLeave": "On Leave",
    "employeeUnavailable": "This employee is on leave for the selected date",
    "startTime": "Start Time",
    "endTime": "End Time",
    "serviceDetails": "Service Details",
    "variant": "Variant",
    "variantPlaceholder": "e.g., Standard, Premium, Full...",
    "specialPrice": "Special Price",
    "regularPrice": "Regular price",
    "lineTotal": "Line Total",
    "serviceNotes": "Service Notes",
    "serviceNotesPlaceholder": "Add notes specific to this service...",
    "printBooking": "Print Booking",
    "tabs": {
      "services": "Services",
      "packages": "Packages"
    },
    "searchPackages": "Search packages...",
    "selectedPackages": "Selected packages",
    "noPackages": "No packages found",
    "packageVariant": "Variant",
    "variants": "variants",
    "items": "items",
    "vehicleTransfer": {
      "title": "Transfer Vehicle Ownership",
      "description": "This vehicle is currently registered to another customer. Do you want to transfer ownership?",
      "warning": "This action will update the vehicle's registered owner. The previous owner will no longer have this vehicle linked to their account.",
      "confirm": "Transfer Ownership",
      "noOwner": "Unregistered"
    },
    "draft": {
      "save": "Save Draft",
      "saved": "Booking draft saved",
      "foundTitle": "Continue Draft?",
      "foundDescription": "You have an unfinished booking draft. Would you like to continue where you left off or start fresh?",
      "continue": "Continue Draft",
      "startNew": "Start New",
      "servicesCount": "services",
      "savedAt": "Saved"
    },
    "rentCarsDesc": "Optionally assign a courtesy vehicle while the customer's car is being serviced",
    "addLoanCar": "Add Loaner Car?",
    "addLoanCarDesc": "Provide a courtesy vehicle while car is in service",
    "selectLoanCarLabel": "Select Loaner Car",
    "startMileage": "Start Mileage (km)",
    "newBooking": "New Booking",
    "noAvailableCars": "No cars available for these dates",
    "noServices": "No services found",
    "noVariants": "No variants available",
    "selectVariant": "Select variant",
    "selectEngineerRequired": "Select at least one engineer",
    "selectVariantRequired": "Select a variant",
    "orderStatuses": {
      "preliminary": "Preliminary",
      "created": "Created",
      "inShop": "In Shop",
      "startService": "Service Started",
      "pickedUp": "Picked Up",
      "finished": "Finished"
    },
    "loanerStatuses": {
      "available": "Available",
      "onLoan": "On Loan",
      "booked": "Booked",
      "cleaning": "Cleaning"
    }
  },
  "scheduler": {
    "schedule": "Schedule",
    "tabs": {
      "schedule": "Schedule",
      "staffAttendance": "Staff & Attendance",
      "checkInList": "Check-in List"
    },
    "checkInListPlaceholder": "Check-in list coming soon",
    "absence": "Absence",
    "today": "Today",
    "newBooking": "New Booking",
    "week": "Week",
    "day": "Day",
    "month": "Month",
    "vehicle": "Vehicle",
    "bookings": "bookings",
    "rows": "rows",
    "notAvailable": "Not Available",
    "absenceManagement": "Absence Management",
    "absenceDescription": "Manage vehicle availability and scheduled maintenance windows.",
    "date": "Date",
    "selectDate": "Select a date",
    "selectVehicle": "Select a vehicle",
    "service": "Service",
    "selectService": "Select a service",
    "time": "Time",
    "selectTime": "Select a time",
    "notes": "Notes",
    "notesPlaceholder": "Add any notes for this booking...",
    "createBooking": "Create Booking",
    "fillAllFields": "Please fill all required fields",
    "bookingCreated": "Booking created successfully",
    "newBookingDescription": "Schedule a new service appointment",
    "noBookings": "No bookings",
    "clickToBook": "Click to book",
    "noNote": "No note",
    "employeeColors": "Technicians",
    "jobDetails": "Booking Details",
    "serviceInfo": "Service Information",
    "vehicleInfo": "Vehicle Information",
    "customerInfo": "Customer Information",
    "assignedTechnician": "Assigned Technician",
    "hoursBooked": "{{booked}}h booked of {{total}}h capacity",
    "overbooked": "⚠️ Day is overbooked!",
    "fullyBooked": "Day is fully booked",
    "availableRentalCars": "Available Rental Cars",
    "noRentalCarsAvailable": "No rental cars available this week",
    "customerVehicles": "Customer Vehicles",
    "loanerCarsFleet": "Loaner Cars Fleet",
    "loanersOut": "loaners out",
    "availableLabel": "available",
    "outLabel": "out",
    "cleaningLabel": "cleaning",
    "vehiclesLabel": "Vehicles",
    "loanersLabel": "Loaners",
    "daysLabel": "days",
    "confirmMove": "Confirm Booking Move",
    "confirmMoveDesc": "Move {{plate}} ({{service}}) to {{date}}{{time}}?",
    "vehicles": "vehicles",
    "moveBooking": "Move Booking",
    "moveToDay": "Move to Day",
    "moveToTime": "Move to Time",
    "pickDate": "Pick a date",
    "noLoanerCars": "No loaner cars available"
  },
  "kanban": {
    "statusTodo": "To Do",
    "statusInProgress": "In Progress",
    "statusDone": "Done",
    "vehicle": "Vehicle",
    "unassigned": "Unassigned",
    "unassignedTooltip": "These tasks need a mechanic assigned",
    "focus": "Focus",
    "focusTooltip": "Highlight a specific mechanic's tasks",
    "allMechanics": "All Mechanics",
    "dropHere": "Drop here",
    "dropHereCross": "Move to this vehicle",
    "moveTask": "Move Task",
    "transferTask": "Transfer Task",
    "moveTaskDesc": "Move \"{{task}}\" from {{from}} to {{to}}?",
    "timeline": "Timeline",
    "kanban": "Kanban",
    "tasks": "tasks",
    "dragTooltip": "Drag to move between columns or vehicles",
    "columnTooltip": "{{status}} — drop tasks here to change status",
    "vehicleTooltip": "Vehicle {{plate}}",
    "progressTooltip": "{{done}} of {{total}} tasks done ({{percent}}%)",
    "addService": "Add Service",
    "addServiceTooltip": "Add a new service task to this vehicle",
    "vehicleNotes": "Vehicle Notes",
    "addServiceTitle": "Add Service",
    "addServiceDesc": "Add a new service to {{plate}}",
    "serviceName": "Service",
    "selectService": "Select a service",
    "estimatedDuration": "Estimated Duration",
    "assignMechanic": "Assign Mechanic",
    "variant": "Variant",
    "selectVariant": "Select a variant",
    "variantRequired": "Please select a variant for this service",
    "noVariants": "No variants available for this service",
    "serviceNotes": "Notes",
    "serviceNotesPlaceholder": "Add any special instructions or notes...",
    "quantity": "Quantity",
    "quantityMin": "Quantity must be at least 1",
    "mandatoryService": "Mandatory Service",
    "mandatory": "Required",
    "pricing": "Pricing",
    "unitPrice": "Unit Price",
    "specialPrice": "Special Price",
    "specialPricePlaceholder": "Override price",
    "lineTotal": "Line Total",
    "serviceAdded": "{{name}} added successfully",
    "vehicleCompleted": "All tasks for {{plate}} are completed!",
    "dragLocked": "Cannot move services when order is {{status}}",
    "allCompleted": "All Vehicles Completed",
    "allCompletedDesc": "All scheduled vehicles have been serviced. Refreshing data...",
    "totalEstimatedTime": "Total estimated work time",
    "mechanicsActive": "mechanics",
    "mechanicsActiveTooltip": "Number of mechanics assigned to current tasks",
    "totalOrderValue": "Total order value across all vehicles",
    "orderStatus": "Order Status",
    "filterByStatus": "Filter by status",
    "allStatuses": "All Statuses",
    "estimatedPickup": "Est. pickup",
    "editPickup": "Click to edit pickup time",
    "pickupUpdated": "Pickup time updated for {{plate}}",
    "orderStatuses": {
      "preliminary": "Preliminary",
      "created": "Created",
      "inShop": "In Shop",
      "startService": "Service Started",
      "pickedUp": "Picked Up",
      "finished": "Finished"
    }
  },
  "punchIn": {
    "title": "Daily Punch In",
    "status": "Current Status",
    "notPunchedIn": "Not Punched In",
    "working": "Working",
    "onBreak": "On Break",
    "todayWorkTime": "Today's Work Time",
    "punchIn": "Punch In",
    "punchOut": "Punch Out",
    "startBreak": "Start Break",
    "endBreak": "End Break",
    "punchedInSuccess": "You have punched in successfully",
    "punchedOutSuccess": "You have punched out successfully",
    "breakStarted": "Break started",
    "breakEnded": "Break ended",
    "todayRecords": "Today's Records",
    "teamStatus": "Team Status",
    "punchedIn": "punched in",
    "enterSecurityPin": "Enter Security PIN",
    "enterPinDescription": "Enter your 4-digit PIN to confirm",
    "pinRequired": "Please enter a 4-digit PIN",
    "invalidPin": "Invalid PIN. Please try again.",
    "recordTypes": {
      "punch_in": "Punch In",
      "punch_out": "Punch Out",
      "break_start": "Break Start",
      "break_end": "Break End"
    }
  },
  "imageUpload": {
    "uploadImage": "Upload image",
    "changeImage": "Change image",
    "removeImage": "Remove image",
    "preview": "Image preview",
    "dragOrClick": "Drag and drop or click to upload",
    "dropHere": "Drop image here",
    "maxSize": "Max {{size}}MB",
    "invalidType": "Invalid file type. Please upload an image.",
    "tooLarge": "File too large. Maximum size is {{size}}MB."
  },
  "filters": {
    "title": "Filters",
    "clearAll": "Clear all",
    "sort": "Sort",
    "sortBy": "Sort by",
    "columns": "Columns",
    "toggleColumns": "Toggle columns",
    "fields": "Fields",
    "toggleFields": "Toggle visible fields",
    "export": "Export",
    "exportCSV": "Export as CSV",
    "exportExcel": "Export as Excel",
    "exportPDF": "Export as PDF",
    "print": "Print",
    "exportSuccess": "Exported as {{format}} successfully",
    "exportFailed": "Export failed. Please try again."
  },
  "leaves": {
    "title": "Leave Management",
    "description": "Track and manage employee leave requests",
    "requestLeave": "Request Leave",
    "requestLeaveDesc": "Submit a new leave request for approval",
    "employee": "Employee",
    "type": "Leave Type",
    "dates": "Dates",
    "days": "Days",
    "daysLabel": "days",
    "reason": "Reason",
    "reasonPlaceholder": "Enter the reason for your leave request",
    "selectDates": "Select Dates",
    "pending": "Pending",
    "approved": "Approved",
    "rejected": "Rejected",
    "requestSubmitted": "Leave request submitted successfully",
    "searchPlaceholder": "Search leaves...",
    "emptyMessage": "No leave requests found",
    "ofTotal": "{{used}} used of {{total}}",
    "types": {
      "annual": "Annual Leave",
      "sick": "Sick Leave",
      "personal": "Personal Leave",
      "unpaid": "Unpaid Leave",
      "vacation": "Vacation",
      "parental": "Parental Leave",
      "vab": "VAB (Sick Child)",
      "other": "Other"
    },
    "tabs": {
      "calendar": "Calendar",
      "absence": "Absence"
    },
    "calendar": {
      "title": "Calendar",
      "subtitle": "Schedule and plan resources",
      "team": "Team",
      "office": "Office",
      "searchEmployees": "Search employees...",
      "showingMine": "My leaves",
      "showingAll": "All employees",
      "legend": {
        "vacation": "Vacation",
        "sick": "Sick Leave",
        "parental": "Parental Leave",
        "vab": "VAB (Sick Child)",
        "unpaid": "Unpaid Leave",
        "pending": "Pending"
      }
    },
    "register": {
      "title": "Apply for Leave",
      "user": "User",
      "selectUser": "Select user...",
      "absenceType": "Absence Type",
      "selectType": "Select type...",
      "dateRange": "Date Range",
      "start": "Start",
      "end": "End",
      "partialDay": "Partial Day",
      "partialDayDesc": "Register hourly absence",
      "startTime": "Start Time",
      "endTime": "End Time",
      "comment": "Comment (optional)",
      "commentPlaceholder": "Any additional notes...",
      "submit": "Apply for Leave",
      "saved": "Leave application submitted",
      "missingFields": "Please fill user, type and dates",
      "available": "Available balance",
      "requested": "Requested",
      "days": "days",
      "insufficientBalance": "Not enough balance for this leave type",
      "noBalanceTracking": "No balance tracking for this type",
      "paid": "Paid",
      "unpaid": "Unpaid",
      "requiresApproval": "Requires approval",
      "autoApproved": "Auto-approved",
      "documentationRequired": "Supporting documentation required",
      "noticeRequired": "Requires {{days}} days' advance notice",
      "insufficientNotice": "Not enough advance notice for this leave type"
    },
    "balance": {
      "vacation": "Vacation",
      "sick": "Sick",
      "vab": "VAB",
      "parental": "Parental",
      "remainingDays": "{{days}} days left"
    }
  },
  "workLogs": {
    "title": "Work Logs",
    "description": "Track daily work hours and activities",
    "addLog": "Add Work Log",
    "addLogDesc": "Log your work hours for the day",
    "employee": "Employee",
    "employees": "employees",
    "selectEmployee": "Select an employee",
    "role": "Role",
    "date": "Date",
    "time": "Time",
    "hours": "Hours",
    "clockIn": "Clock In",
    "clockOut": "Clock Out",
    "breakDuration": "Break",
    "breakMin": "Break (min)",
    "overtime": "Overtime",
    "overtimeTooltip": "Hours worked beyond regular schedule",
    "efficiency": "Efficiency",
    "avgEfficiency": "Avg Efficiency",
    "jobsCompleted": "Jobs Completed",
    "jobs": "jobs",
    "notes": "Notes",
    "notesPlaceholder": "Describe your work activities...",
    "today": "Today",
    "yesterday": "yesterday",
    "thisWeek": "This Week",
    "total": "total",
    "ongoing": "Ongoing",
    "activeNow": "Active Now",
    "allStatuses": "All Statuses",
    "statusCompleted": "Completed",
    "statusInProgress": "In Progress",
    "statusOnBreak": "On Break",
    "statusAbsent": "Absent",
    "employeesClocked": "Clocked In",
    "totalHours": "Total Hours",
    "logSubmitted": "Work log submitted successfully",
    "searchPlaceholder": "Search by name, date, or notes...",
    "emptyMessage": "No work logs found"
  },
  "billing": {
    "title": "Invoicing",
    "description": "Manage invoices and track payments",
    "createInvoice": "Create Invoice",
    "createInvoiceDesc": "Create a new invoice for a customer",
    "customer": "Customer",
    "selectCustomer": "Select a customer",
    "invoiceNumber": "Invoice #",
    "amount": "Amount",
    "dueDate": "Due Date",
    "notes": "Notes",
    "notesPlaceholder": "Add any notes for this invoice...",
    "draft": "Draft",
    "sent": "Sent",
    "paid": "Paid",
    "late": "Late",
    "totalRevenue": "Total Revenue",
    "pendingPayments": "Pending Payments",
    "overdueAmount": "Overdue Amount",
    "totalInvoices": "Total Invoices",
    "invoiceSent": "Invoice sent successfully",
    "invoiceCreated": "Invoice created successfully",
    "downloaded": "Invoice downloaded",
    "searchPlaceholder": "Search invoices...",
    "emptyMessage": "No invoices found",
    "tabs": {
      "overview": "Overview",
      "invoicing": "Invoicing",
      "supplierInvoices": "Supplier Invoices",
      "timesheets": "Timesheets"
    },
    "customerVehicleTitle": "Customer & Vehicle",
    "searchCustomerOrVehicle": "Search by name, email, phone, reg. number or model…",
    "customersGroup": "Customers",
    "vehiclesGroup": "Vehicles",
    "noResults": "No results found.",
    "selectedCustomer": "Customer",
    "selectedVehicle": "Vehicle",
    "noCustomerSelected": "No customer selected",
    "noVehicleSelected": "No vehicle selected",
    "pickVehicleHint": "Optional — pick from this customer's vehicles below",
    "clearSelection": "Clear",
    "invoiceDetails": "Invoice Details",
    "invoiceType": "Invoice Type",
    "invoiceTypePlaceholder": "Select a bill type",
    "billTypeOptions": {
      "bill": "Bill",
      "creditBill": "Credit Bill",
      "cashBill": "Cash Bill",
      "collectiveInvoice": "Collective Invoice"
    },
    "status": "Status",
    "currency": "Currency",
    "billingDate": "Billing Date",
    "paymentDate": "Payment Date",
    "paymentDays": "Payment Days",
    "bookedBy": "Booked By",
    "bookedByPlaceholder": "Booker ID",
    "comments": "Comments",
    "commentsPlaceholder": "Additional billing comments…",
    "driverInformation": "Customer Information",
    "driverIDLabel": "Customer ID",
    "driverIDPlaceholder": "Customer UUID",
    "firstName": "First Name",
    "lastName": "Last Name",
    "email": "Email",
    "phoneNumber": "Phone Number",
    "address": "Address",
    "zipCode": "Zip Code",
    "city": "City",
    "country": "Country",
    "driverHasCard": "Customer has card",
    "cardNumber": "Card Number",
    "cardValidTo": "Card Valid To",
    "keyNumber": "Key Number",
    "companyReferenceTitle": "Company & Reference",
    "companyOrgNumber": "Company Org Number",
    "companyReference": "Company Reference",
    "driverExternalNumber": "Customer External Number",
    "ordersSectionTitle": "Orders",
    "searchOrders": "Search orders by number…",
    "selectCustomerForOrders": "Select a customer to see their orders",
    "added": "Added",
    "currencyMismatch": "{{currency}} differs from invoice",
    "noOrdersFound": "No matching orders.",
    "noOrdersAttached": "No orders attached.",
    "services": "Services",
    "products": "Products",
    "viewBreakdown": "View breakdown",
    "hideBreakdown": "Hide breakdown",
    "miscItems": "Miscellaneous items",
    "addItem": "Add item",
    "noMiscItems": "No miscellaneous items.",
    "miscDescription": "Description",
    "miscQty": "Qty",
    "miscPrice": "Price",
    "miscDiscount": "Discount",
    "miscVat": "VAT %",
    "miscTotal": "Total",
    "removeItem": "Remove item",
    "summary": "Summary",
    "subtotal": "Subtotal",
    "discount": "Discount",
    "vat": "VAT",
    "total": "Total",
    "billedAmountOverride": "Billed Amount (override)",
    "billedAmount": "Billed Amount",
    "newInvoice": "New Invoice",
    "newInvoiceDescription": "Create a new invoice by filling in the driver, company and billing details.",
    "saveAsDraft": "Save as Draft",
    "invoiceSavedDraft": "Invoice saved as draft",
    "pleaseFillForm": "Please fill in the form",
    "bookedByRequired": "Booked By is required",
    "noStoreSelected": "Select a store from the top bar before saving an invoice",
    "invoiceSaved": "Invoice saved",
    "invoiceNotFound": "Invoice not found",
    "invoiceUpdated": "Invoice updated",
    "smsNotificationSent": "SMS notification sent",
    "emailNotificationSent": "Email notification sent",
    "notifySms": "Notify SMS",
    "notifyEmail": "Notify Email",
    "invoiceWithId": "Invoice {{id}}",
    "errors": {
      "billTypeRequired": "Invoice type is required",
      "billTypeInvalid": "Select a valid invoice type",
      "currencyRequired": "Currency is required",
      "billedAmountMin": "Amount must be 0 or greater",
      "qtyMin": "Quantity must be 0 or greater",
      "unitPriceMin": "Unit price must be 0 or greater",
      "discountMin": "Discount must be 0 or greater",
      "taxRateRange": "VAT must be between 0 and 100"
    },
    "driver": "Driver",
    "statusAll": "All",
    "statusSent": "Sent",
    "invoiceCustomer": "Invoice / Customer",
    "invoiceNumberValue": "INV-{{number}}",
    "statusUpdated": "Invoice status updated",
    "reminderSent": "Reminder sent",
    "numberCopied": "Invoice number copied",
    "copyFailed": "Could not copy to clipboard",
    "billedFrom": "Billed from",
    "billedTo": "Billed to",
    "rowActions": {
      "open": "More actions",
      "viewDetails": "View Details",
      "sendEmail": "Send Email",
      "sendReminder": "Send Reminder",
      "createReminderInvoice": "Create Reminder Invoice",
      "markAsPaid": "Mark as Paid",
      "fullCredit": "Full Credit",
      "partialCredit": "Partial Credit",
      "downloadPdf": "Download PDF",
      "copyNumber": "Copy Invoice Number"
    },
    "reminderCount": "Reminder Count",
    "internalNotes": "Internal Notes",
    "internalNotesPlaceholder": "Notes for your team about this invoice…",
    "internalNotesHint": "Only visible to staff — never printed on the invoice.",
    "internalNotesSaved": "Internal notes saved",
    "lastActionColumn": "Last Action",
    "lastAction": {
      "created": "Created",
      "reminded": "Reminder sent",
      "Draft": "Moved to draft",
      "Sent": "Sent",
      "Late": "Marked as late",
      "Paid": "Marked as paid",
      "emailed": "Emailed",
      "PartiallyPaid": "Partial payment",
      "Credited": "Credited"
    },
    "issuedNotEditable": "Issued invoices can’t be edited. Only drafts can be changed.",
    "partiallyPaid": "Partially Paid",
    "credited": "Credited",
    "creditInvoiceTag": "Credit invoice",
    "paymentRegistered": "Payment registered",
    "creditInvoiceCreated": "Credit invoice {{number}} created",
    "reminderInvoiceCreated": "Reminder invoice {{number}} created",
    "invoiceEmailed": "Invoice emailed to the customer",
    "payment": {
      "title": "Register payment — {{number}}",
      "outstanding": "Outstanding: {{amount}}",
      "amount": "Amount paid",
      "amountInvalid": "Enter an amount above 0 and at most {{max}}",
      "partialHint": "Less than what is owed — the invoice becomes Partially Paid.",
      "date": "Payment date",
      "note": "Note (optional)",
      "notePlaceholder": "e.g. Swish, bank transfer reference…",
      "submit": "Register payment"
    },
    "credit": {
      "fullTitle": "Fully credit {{number}}?",
      "fullDescription": "A credit invoice for {{amount}} will be issued and the invoice marked as Credited.",
      "paidHint": "{{amount}} has already been paid on this invoice — refund the customer separately.",
      "submitFull": "Issue credit invoice",
      "partialTitle": "Partially credit {{number}}",
      "partialDescription": "Choose how many units of each row to credit. A credit invoice is issued for the selection.",
      "row": "Row",
      "billed": "Billed qty",
      "unitPrice": "Unit price",
      "quantityToCredit": "Qty to credit",
      "quantityFor": "Quantity to credit for {{row}}",
      "noRows": "This invoice has no rows to credit.",
      "total": "Credit total (incl. VAT)",
      "submitPartial": "Issue credit invoice"
    },
    "reminderInvoice": {
      "title": "Reminder invoice for {{number}}",
      "description": "Issues a new invoice for the reminder fee, due in 10 days. Reminder fees are VAT-exempt.",
      "fee": "Reminder fee ({{currency}})",
      "feeHint": "Prefilled from the store's default reminder fee.",
      "noDefaultFeeHint": "Tip: set a default reminder fee in the branch payment settings.",
      "submit": "Create reminder invoice"
    },
    "sendEmail": {
      "title": "Email {{number}} to the customer?",
      "description": "The invoice will be sent to {{email}}.",
      "draftHint": "This draft will be issued and marked as Sent.",
      "submit": "Send email"
    },
    "useCalculatedTotal": "Use calculated total"
  },
  "timesheets": {
    "title": "Timesheets",
    "description": "Approvals, salary basis and attendance",
    "subTabs": {
      "approvals": "Approvals",
      "salaryBasis": "Salary Basis",
      "attendanceControl": "Attendance Control"
    },
    "createReport": "Create Report",
    "newTimesheet": "New Timesheet",
    "type": "Type",
    "office": "Office",
    "allOffices": "All Offices",
    "allStatus": "All Status",
    "hours": "Hours",
    "mileage": "Mileage",
    "amount": "Amount",
    "status": {
      "draft": "Draft",
      "submitted": "Submitted",
      "approved": "Approved",
      "returned": "Returned",
      "paid": "Paid"
    },
    "types": {
      "timesheet": "Timesheet",
      "outlay": "Outlay"
    },
    "search": "Search employee...",
    "empty": "No timesheets found",
    "created": "Timesheet created successfully",
    "entryCreated": "Timesheet entry created successfully",
    "approvalCreated": "Approval submitted successfully",
    "editor": {
      "back": "Back",
      "saveDraft": "Save Draft",
      "submitReport": "Submit Report",
      "fieldWorkReport": "Field Work Report",
      "flexTime": "Flex-Time",
      "day": "Day",
      "start": "Start",
      "end": "End",
      "break": "Break",
      "worked": "Worked",
      "allocated": "Allocated",
      "diff": "Diff",
      "note": "Note",
      "dailyNote": "Daily note...",
      "weekend": "Weekend",
      "checkIns": "Check-ins",
      "jobs": "jobs",
      "distribute": "Distribute",
      "addAllocation": "+ Allocation",
      "addMileage": "Mileage",
      "progress": "Progress",
      "draftStep": "Draft",
      "submittedStep": "Submitted",
      "managerReview": "Manager Review",
      "payrollProcessed": "Payroll Processed",
      "livePayroll": "Live Payroll Summary",
      "regularHours": "Regular Hours",
      "unallocated": "Unallocated (Admin/Travel)",
      "workingDays": "Working Days",
      "baseSalary": "Base Salary",
      "commission": "Commission",
      "grossTotal": "Gross Total",
      "rateBreakdown": "{{rate}} × {{hours}}h + Mileage",
      "comments": "Comments",
      "noComments": "No comments yet.",
      "addComment": "Add a comment...",
      "submittedToast": "Timesheet submitted",
      "draftSaved": "Draft saved",
      "salesReport": "Sales Report",
      "officeReport": "Office Report",
      "mileage": "Mileage",
      "clickToEdit": "Click to edit",
      "overrideWithWork": "— Override with work"
    }
  },
  "products": {
    "title": "Products & Inventory",
    "description": "Manage your product catalog and stock levels",
    "addProduct": "Add Product",
    "addProductDesc": "Add a new product to your inventory",
    "name": "Product Name",
    "namePlaceholder": "e.g. Engine Oil 5W-30",
    "sku": "SKU",
    "category": "Category",
    "selectCategory": "Select a category",
    "price": "Selling Price",
    "cost": "Cost Price",
    "margin": "Margin",
    "stock": "Stock",
    "reorderLevel": "Reorder Level",
    "inStock": "In Stock",
    "lowStock": "Low Stock",
    "outOfStock": "Out of Stock",
    "totalProducts": "Total Products",
    "inventoryValue": "Inventory Value",
    "totalStock": "Total Stock Units",
    "productAdded": "Product added successfully",
    "searchPlaceholder": "Search products...",
    "emptyMessage": "No products found",
    "categories": {
      "accessories": "Accessories",
      "brakes": "Brakes",
      "engine": "Engine",
      "filters": "Filters",
      "oils": "Oils"
    },
    "productUpdated": "Product updated",
    "productDeleted": "Product deleted",
    "deleteConfirm": "Are you sure you want to delete {{name}}? This cannot be undone.",
    "currency": "Currency",
    "externalArticleNumber": "External Article Number",
    "selectStore": "Select a store",
    "updateRelatedData": "Update related data",
    "updateRelatedDataDesc": "Automatically update related records when this product changes",
    "required": "Required",
    "basicInfo": "Basic Information",
    "itemNumber": "Item Number",
    "type": "Type",
    "typeLocal": "Local",
    "typeGlobal": "Global",
    "formDescription": "Description",
    "categoryId": "Category ID",
    "pricingTitle": "Pricing",
    "priceAward": "Price (Award)",
    "inventoryTitle": "Inventory",
    "inventoryBalance": "Inventory Balance",
    "storeId": "Store ID",
    "supplierRefTitle": "Supplier & References",
    "supplierArticleNumber": "Supplier Article Number"
  },
  "rentalFleet": {
    "title": "Rental Fleet",
    "description": "Manage your rental vehicle fleet",
    "addVehicle": "Add Vehicle",
    "addVehicleDesc": "Add a new vehicle to the rental fleet",
    "vehicle": "Vehicle",
    "vehiclePlaceholder": "e.g. Toyota Corolla 2024",
    "licensePlate": "License Plate",
    "mileage": "Mileage",
    "customer": "Customer",
    "selectCustomer": "Select customer",
    "rentalPeriod": "Rental Period",
    "startDate": "Start Date",
    "expectedReturn": "Expected Return",
    "available": "Available",
    "onLoan": "Rented Out",
    "maintenance": "In Maintenance",
    "totalVehicles": "Total Vehicles",
    "assign": "Assign",
    "return": "Return",
    "assignCar": "Assign Vehicle",
    "vehicleAdded": "Vehicle added successfully",
    "vehicleUpdated": "Vehicle updated successfully",
    "vehicleAssigned": "Vehicle assigned to customer",
    "vehicleReturned": "Vehicle returned successfully",
    "searchPlaceholder": "Search rental fleet...",
    "emptyMessage": "No rental vehicles found",
    "vehicleInfo": "Vehicle Information",
    "rentalInfo": "Rental Information",
    "fillRequired": "Please fill in required fields",
    "blacklisted": "Blacklisted",
    "deleteConfirm": "Are you sure you want to delete {{name}}? This cannot be undone.",
    "noRentCarHistory": "No rental history for this vehicle",
    "rentCarHistory": "Rental History",
    "carNumber": "Car Number",
    "notesTitle": "Notes",
    "required": "Required",
    "regNumTooShort": "Registration number must be at least 3 characters",
    "regNumTooLong": "Registration number must be at most 11 characters",
    "carNumberTooLong": "Car number must be at most 32 characters",
    "history": {
      "orderId": "Order ID",
      "bookedBy": "Booked By",
      "start": "Start",
      "end": "End",
      "created": "Created",
      "active": "Active",
      "completed": "Completed",
      "cancelled": "Cancelled"
    }
  },
  "campaigns": {
    "title": "Campaigns",
    "description": "Create and manage marketing campaigns",
    "createCampaign": "Create Campaign",
    "createCampaignDesc": "Set up a new marketing campaign",
    "name": "Campaign Name",
    "namePlaceholder": "e.g. Winter Service Special",
    "type": "Type",
    "email": "Email",
    "sms": "SMS",
    "promotion": "Promotion",
    "audience": "Audience",
    "selectAudience": "Select target audience",
    "message": "Message",
    "messagePlaceholder": "Write your campaign message...",
    "draft": "Draft",
    "scheduled": "Scheduled",
    "active": "Active",
    "completed": "Completed",
    "sent": "Sent",
    "send": "Send",
    "performance": "Performance",
    "openRate": "Open Rate",
    "clickRate": "Click Rate",
    "totalCampaigns": "Total Campaigns",
    "totalSent": "Total Messages Sent",
    "avgOpenRate": "Avg. Open Rate",
    "avgClickRate": "Avg. Click Rate",
    "allCampaigns": "All Campaigns",
    "customerSegments": "Customer Segments",
    "customers": "customers",
    "targetSegment": "Target This Segment",
    "campaignCreated": "Campaign created successfully",
    "campaignSent": "Campaign sent successfully",
    "searchPlaceholder": "Search campaigns...",
    "emptyMessage": "No campaigns found"
  },
  "integrations": {
    "title": "Integrations",
    "description": "Connect your favorite tools and services",
    "totalIntegrations": "Total Integrations",
    "connected": "Connected",
    "available": "Available",
    "configure": "Configure",
    "configureDesc": "Update the settings for this integration",
    "apiKey": "API Key",
    "webhookUrl": "Webhook URL",
    "webhookUrlPlaceholder": "https://...",
    "configSaved": "Configuration saved successfully",
    "categories": {
      "payment": "Payments",
      "communication": "Communication",
      "calendar": "Calendar",
      "accounting": "Accounting"
    },
    "disconnected": "Disconnected",
    "fortnox": {
      "description": "Sync invoices and customers to your Fortnox bookkeeping.",
      "notConnected": "Not connected",
      "statusError": "Connection error",
      "connectedHint": "New invoices are sent to Fortnox automatically.",
      "notConnectedHint": "Connect your organization's Fortnox account. You'll be sent to Fortnox to approve access, then brought back here.",
      "connect": "Connect Fortnox",
      "reconnect": "Reconnect Fortnox",
      "disconnect": "Disconnect",
      "disconnectConfirmTitle": "Disconnect Fortnox?",
      "disconnectConfirmDescription": "Invoices will stop syncing to Fortnox until you connect again. Nothing already in Fortnox is deleted.",
      "disconnectedToast": "Fortnox disconnected",
      "connectFailed": "Could not start the Fortnox connection",
      "disconnectFailed": "Could not disconnect Fortnox",
      "loadFailed": "Could not load the Fortnox connection status.",
      "lastError": "Last error: {{error}}",
      "callback": {
        "connected": "Fortnox connected",
        "declined": "Fortnox access was declined",
        "invalid": "The Fortnox connection link expired or was invalid. Please try again.",
        "error": "Fortnox could not be connected. Please try again."
      }
    }
  },
  "companies": {
    "addCompany": "Add Company",
    "addCompanyDesc": "Add a new company to your database",
    "companyAdded": "Company added successfully",
    "form": {
      "companyInfo": "Company Information",
      "companyInfoDesc": "Enter the company details",
      "companyNumber": "Company Number",
      "addressInfo": "Address Information",
      "addressInfoDesc": "Enter the company's physical address",
      "billingInfo": "Billing Information",
      "billingInfoDesc": "Configure billing preferences",
      "billingEmail": "Billing Email",
      "billingEmailDesc": "Separate email for invoices",
      "paymentTerms": "Payment Terms (days)",
      "paymentTermsDesc": "Number of days until payment is due",
      "drivers": "Contact Persons",
      "driversDesc": "Add contact persons associated with this company",
      "addDriver": "Add Contact",
      "driver": "Contact",
      "notes": "Notes",
      "sharedNotes": "Shared Notes",
      "sharedNotesPlaceholder": "Notes visible to all staff...",
      "sharedNotesDesc": "These notes will be visible to all staff members",
      "internalNotes": "Internal Notes",
      "internalNotesPlaceholder": "Private notes...",
      "internalNotesDesc": "These notes are only visible to management",
      "driverInfo": "Primary Driver / Contact",
      "driverInfoDesc": "Search an existing customer to pre-fill, or fill in the form for a new driver.",
      "searchCustomerPlaceholder": "Search existing customers to pre-fill…"
    },
    "companyUpdated": "Company updated successfully"
  },
  "categories": {
    "title": "Categories",
    "tabs": {
      "service": "Service Categories",
      "product": "Product Categories"
    },
    "searchPlaceholder": "Search categories...",
    "addServiceCategory": "Add Service Category",
    "addProductCategory": "Add Product Category",
    "serviceCategories": "Service Categories",
    "productCategories": "Product Categories",
    "serviceCategory": "Service Category",
    "productCategory": "Product Category",
    "serviceCount": "Services",
    "productCount": "Products",
    "services": "services",
    "products": "products",
    "color": "Color",
    "details": "Category Details",
    "overview": "Overview",
    "createdAt": "Created",
    "updatedAt": "Updated",
    "namePlaceholder": "Enter category name",
    "descriptionPlaceholder": "Enter category description",
    "nameRequired": "Category name is required",
    "nameTooShort": "Category name must be at least 3 characters",
    "savedSuccess": "Category saved successfully",
    "deletedSuccess": "Category deleted successfully",
    "createdSuccess": "Category created successfully",
    "emptyServiceCategories": "No service categories found",
    "emptyProductCategories": "No product categories found",
    "image": "Category Image",
    "serviceDeleteConfirm": "Are you sure you want to delete {{name}}? This cannot be undone.",
    "productDeleteConfirm": "Are you sure you want to delete {{name}}? This cannot be undone."
  },
  "tooltips": {
    "sidebar": {
      "expand": "Expand sidebar",
      "collapse": "Collapse sidebar"
    },
    "nav": {
      "booking": "Manage bookings and appointments",
      "customers": "View and manage customer records",
      "vehicles": "Track registered vehicles",
      "services": "Browse and manage service catalog",
      "jobs": "Track work orders and jobs",
      "leaves": "Manage employee leave requests",
      "workLogs": "Monitor daily work hours",
      "myWork": "Your personal work log and leaves",
      "myWorkspace": "Your personal ERP: leaves, timesheets, overtime, overview",
      "teamOverview": "Manage your team: status, approvals, calendar",
      "billing": "Manage invoices and payments",
      "products": "View product inventory",
      "categories": "Manage service and product categories",
      "rentalFleet": "Manage rental vehicle fleet",
      "campaigns": "Create marketing campaigns",
      "communication": "Manage email and SMS templates",
      "reviews": "Customer reviews and ratings",
      "settings": "System preferences and configuration"
    },
    "topbar": {
      "search": "Search by registration number",
      "store": "Switch between store locations",
      "notifications": "View recent notifications",
      "userMenu": "Account settings and preferences"
    },
    "quickActions": {
      "newCustomer": "Register a new customer in the system",
      "addVehicle": "Add a new vehicle to the registry",
      "createJob": "Create a new work order",
      "newService": "Add a new service to the catalog"
    },
    "viewSwitcher": {
      "cards": "Display items as cards",
      "list": "Display items in a table"
    },
    "filters": {
      "clearSearch": "Clear search field",
      "filter": "Apply filters to narrow results",
      "sort": "Change sorting order",
      "columns": "Toggle visible columns",
      "export": "Export data to file",
      "print": "Print current view"
    }
  },
  "tour": {
    "title": "Welcome Tour",
    "stepOf": "Step {{current}} of {{total}}",
    "skip": "Skip tour",
    "next": "Next",
    "prev": "Back",
    "finish": "Got it!",
    "steps": {
      "logo": {
        "title": "Welcome to Care of Cars!",
        "description": "Click the logo anytime to return to your dashboard. This is your home base for managing everything."
      },
      "sidebarNav": {
        "title": "Navigation Menu",
        "description": "Access all modules here — Bookings, Customers, Vehicles, Services, Jobs, and more. The sidebar collapses automatically on settings pages and can be toggled manually."
      },
      "pageTitle": {
        "title": "Page Title & Context",
        "description": "This area shows the current page name and a helpful subtitle describing what you can do here."
      },
      "search": {
        "title": "Quick Search",
        "description": "Search across vehicles, customers, and bookings instantly. Type a license plate or customer name to jump straight to results."
      },
      "store": {
        "title": "Store Selector",
        "description": "If you manage multiple branches or locations, switch between them here. Your data and settings are scoped to the active store."
      },
      "howTo": {
        "title": "How To Guide",
        "description": "Click this button anytime to replay the guided tour and learn about each section of the interface."
      },
      "userMenu": {
        "title": "Your Account",
        "description": "Access your profile, settings, language preferences, and organization switcher. You can also log out from here."
      },
      "mainContent": {
        "title": "Main Workspace",
        "description": "This is where the action happens! Each page shows relevant data, forms, and tools. Explore the sidebar to discover all available modules."
      },
      "bookingModeToggle": {
        "title": "Timeline vs Kanban",
        "description": "Switch between Timeline and Kanban views. Timeline shows a Gantt-style calendar with day/week/month breakdowns. Kanban organizes bookings into status columns for quick workflow management."
      },
      "bookingViewTabs": {
        "title": "Day / Week / Month",
        "description": "In Timeline mode, toggle between Day, Week, and Month views. Day shows hourly slots, Week shows a full 7-day Gantt chart, and Month gives you a high-level overview."
      },
      "bookingNavControls": {
        "title": "Navigate Dates",
        "description": "Use the arrows to move forward or backward through dates. The label shows the current period. Click 'Today' to jump back to the current date."
      },
      "bookingNewBtn": {
        "title": "Create a Booking",
        "description": "Click here to create a new booking. You can also drag and drop existing bookings across dates or status columns to reschedule or update their status."
      },
      "bookingDragDrop": {
        "title": "Drag & Drop Bookings",
        "description": "Grab any booking bar and drag it to a different day column (Week view) or time slot (Day view) to reschedule. A highlighted drop zone shows where it will land, and you'll be asked to confirm before the move is applied."
      },
      "dayTimeHeader": {
        "title": "Time Slots",
        "description": "The top row shows hourly time slots. Click any slot to create a new booking at that time, or drop a dragged booking onto a slot to reschedule it there."
      },
      "dayVehicleRow": {
        "title": "Vehicle Timeline",
        "description": "Each row represents a vehicle with its bookings as colored bars. Drag a bar left or right to move it to a different time slot, or drag it across rows."
      },
      "newBookingSteps": {
        "title": "Step-by-Step Wizard",
        "description": "The booking flow is split into 4 steps: Customer & Vehicle, Services, Schedule, and Confirm. Click any completed step to jump back and edit."
      },
      "newBookingCustomerTab": {
        "title": "Customer or Vehicle First",
        "description": "Start by searching for a customer or switch to 'By Vehicle' to find by license plate. Selecting one auto-links the other. If not found, use 'Add New' to create inline."
      },
      "newBookingServices": {
        "title": "Select Services",
        "description": "Browse and filter services by category. Click a service to assign mechanics, set quantity, special pricing, and notes. Selected services appear in the summary below."
      },
      "newBookingSchedule": {
        "title": "Schedule & Loan Car",
        "description": "Pick intake and delivery dates/times. Mark as preliminary if tentative. Toggle the loan car switch to assign a courtesy vehicle with start mileage tracking."
      },
      "newBookingConfirm": {
        "title": "Review & Confirm",
        "description": "Review all details, adjust VAT-free toggle or discount percentage, then confirm. Use the print button to generate a summary. Your draft is auto-saved so you can return anytime."
      },
      "newBookingNav": {
        "title": "Navigation Controls",
        "description": "Use Back/Next to move between steps. The Next button is disabled until required fields are filled. On the final step, click Confirm to create the booking."
      }
    },
    "pages": {
      "dashboard": {
        "header": {
          "title": "Your Dashboard",
          "description": "This is your home base. The page title and quick KPIs summarise today's activity at a glance."
        },
        "main": {
          "title": "Daily Overview",
          "description": "Track today's revenue, bookings, employees on shift and services. Low-inventory alerts and weekly notes also appear here."
        }
      },
      "customers": {
        "header": {
          "title": "Customers",
          "description": "Manage individual and company customers. Add new customers, view their vehicles and booking history."
        },
        "main": {
          "title": "Customer List",
          "description": "Filter, search and export your customer base. Click any row to open a 360° customer profile with vehicles, bookings and invoices."
        }
      },
      "vehicles": {
        "header": {
          "title": "Vehicles",
          "description": "All vehicles registered in the workshop. Onboard new vehicles by registration number."
        },
        "main": {
          "title": "Vehicle List",
          "description": "Use filters and search to locate vehicles fast. Open a vehicle to see its owner, service history and upcoming bookings."
        }
      },
      "jobs": {
        "header": {
          "title": "Jobs",
          "description": "Active and completed service jobs across the workshop."
        },
        "main": {
          "title": "Job Management",
          "description": "Use 'Create Job' to start a new booking. Track status, assigned mechanics and linked invoices for every job."
        }
      },
      "newBooking": {
        "rentcars": {
          "title": "Loaner / Rental Vehicle",
          "description": "Optionally assign a rental or loaner car to the booking. Availability is checked against your rental fleet for the selected dates."
        }
      },
      "pricing": {
        "header": {
          "title": "Pricing",
          "description": "Centralised pricing rules for services, packages and add-ons."
        },
        "main": {
          "title": "Pricing Rules",
          "description": "Adjust default prices, discounts and special rates. Changes apply across all new bookings and invoices."
        }
      },
      "myWorkspace": {
        "header": {
          "title": "My Workspace",
          "description": "Your personal hub: punch in/out, work logs, leaves and assigned jobs."
        },
        "main": {
          "title": "Personal Overview",
          "description": "Switch between tabs to view today's shift, log time, request leave or check your job queue."
        }
      },
      "teamOverview": {
        "header": {
          "title": "Team Overview",
          "description": "Real-time visibility of your team — who's clocked in, on break, on leave or off duty."
        },
        "main": {
          "title": "Team Status",
          "description": "Live status board with attendance, work logs and team KPIs. Filter by store or role."
        }
      },
      "invoicing": {
        "header": {
          "title": "Invoicing & Billing",
          "description": "Create and manage invoices, quotes and credit notes for completed jobs."
        },
        "main": {
          "title": "Invoice List",
          "description": "Use tabs to filter by status. Open any invoice to view line items, print, email or mark as paid."
        }
      },
      "economy": {
        "header": {
          "title": "Economy",
          "description": "Financial overview — revenue, expenses, profit and tax summaries."
        },
        "main": {
          "title": "Financial Reports",
          "description": "Drill into period reports, export figures and reconcile with your accounting."
        }
      },
      "products": {
        "header": {
          "title": "Products",
          "description": "Parts and product inventory used during services."
        },
        "main": {
          "title": "Product Catalogue",
          "description": "Manage stock levels, supplier info and pricing. Low-stock items trigger alerts on the dashboard."
        }
      },
      "rentalFleet": {
        "header": {
          "title": "Rental Fleet",
          "description": "Loaner and rental vehicles available to customers during service."
        },
        "main": {
          "title": "Fleet Management",
          "description": "Track availability, current renters and rental history per vehicle. Add new vehicles to the fleet here."
        }
      },
      "campaigns": {
        "header": {
          "title": "Campaigns",
          "description": "Marketing campaigns and customer outreach."
        },
        "main": {
          "title": "Campaign List",
          "description": "Create new campaigns, target customer segments and track engagement metrics."
        }
      },
      "account": {
        "header": {
          "title": "My Account",
          "description": "Profile, security settings and login history for your user."
        },
        "main": {
          "title": "Account Details",
          "description": "Update your personal info, change password, manage 2FA and review recent logins."
        }
      },
      "settings": {
        "header": {
          "title": "Settings",
          "description": "Workshop-wide configuration — branch info, staff, services, working hours, integrations and more."
        },
        "main": {
          "title": "Settings Sections",
          "description": "Use the side navigation to jump between sections. Changes are scoped to the active store unless marked global."
        }
      }
    }
  },
  "communication": {
    "tabs": {
      "email": "Email Templates",
      "sms": "SMS Templates",
      "automations": "Automations"
    },
    "automations": {
      "title": "Automations",
      "description": "Choose which email and/or SMS template fires automatically for each event.",
      "eventLabel": {
        "orderCreated": "Order created",
        "orderStatusChanged": "Order status changed",
        "orderFinished": "Order finished",
        "customerCreated": "Customer created",
        "customerUpdated": "Customer updated",
        "vehicleCreated": "Vehicle entry",
        "billCreated": "Invoice created",
        "billUpdated": "Invoice updated",
        "billSent": "Bill sent",
        "billReminder": "Invoice payment reminder",
        "employeeCreated": "Employee created",
        "employeeUpdated": "Employee updated",
        "employeeWelcome": "Employee welcome email",
        "leaveApplied": "Leave application submitted",
        "leaveApproved": "Leave application approved",
        "timesheetSubmitted": "Timesheet submitted",
        "inviteCreated": "Invite created",
        "inviteUpdated": "Invite updated",
        "bookingCreated": "Booking created",
        "bookingUpdated": "Booking updated",
        "rentalBookingCreated": "Rental booking created",
        "rentalBookingUpdated": "Rental booking updated"
      },
      "category": {
        "orders": "Orders",
        "customers": "Customers",
        "vehicles": "Vehicles",
        "invoicing": "Invoicing",
        "employees": "Employees",
        "invites": "Invites",
        "scheduling": "Scheduling",
        "rentalBooking": "Rental Booking"
      },
      "emailTemplateLabel": "Email template",
      "smsTemplateLabel": "SMS template",
      "noneOption": "None",
      "activeLabel": "Active",
      "atLeastOneChannelRequired": "Select at least one email or SMS template",
      "saved": "Automation saved",
      "saveFailed": "Failed to save automation",
      "storeOverridesTitle": "Store overrides",
      "storeOverridesDescription": "Override the org-wide automation above for a specific store.",
      "noStoreOverrides": "No store overrides yet.",
      "newAutomation": "New automation",
      "newAutomationTitle": "New automation",
      "editAutomationTitle": "Edit automation",
      "storeLabel": "Store",
      "selectStore": "Select store",
      "actionLabel": "Action",
      "selectAction": "Select action",
      "storeRequired": "Store is required",
      "actionRequired": "Action is required",
      "createAutomation": "Create automation",
      "saveChanges": "Save changes",
      "deleteConfirmTitle": "Delete this store override?",
      "deleteConfirmDescription": "This action cannot be undone.",
      "deleted": "Automation deleted",
      "deleteFailed": "Failed to delete automation"
    },
    "searchPlaceholder": "Search templates...",
    "addEmailTemplate": "New Email Template",
    "addSmsTemplate": "New SMS Template",
    "newEmailTemplate": "New Email Template",
    "newSmsTemplate": "New SMS Template",
    "editEmailTemplate": "Edit Email Template",
    "editSmsTemplate": "Edit SMS Template",
    "templateDetails": "Template Details",
    "templateCreated": "Template created successfully",
    "templateUpdated": "Template updated successfully",
    "templateDeleted": "Template deleted successfully",
    "noTemplates": "No templates found",
    "dynamicVariables": "Dynamic Variables",
    "variablesHelp": "Click a variable to insert it into the template body",
    "usedVariables": "Used",
    "chars": "characters",
    "segments": "segments",
    "multipleSegments": "This message will be sent as multiple segments",
    "preview": "Preview",
    "livePreview": "Live Preview",
    "previewEmpty": "Start typing to see a preview...",
    "deleteConfirm": "Delete this template?",
    "deleteDescription": "This action cannot be undone. The template will be permanently deleted.",
    "fields": {
      "name": "Template Name",
      "templateName": "Template Name",
      "templateTitle": "Template Title",
      "templateCategory": "Category",
      "templateType": "Type",
      "templateTypeNone": "Not tagged",
      "body": "Email Body",
      "message": "Message"
    },
    "placeholders": {
      "templateName": "e.g. booking-confirmation",
      "templateTitle": "e.g. Booking Confirmation",
      "emailBody": "Write your email HTML content here...",
      "smsBody": "Write your SMS message here..."
    },
    "errors": {
      "templateNameRequired": "Template name is required",
      "templateNameTooLong": "Template name must be at most {{max}} characters",
      "templateTitleRequired": "Template title is required",
      "templateTitleTooLong": "Template title must be at most {{max}} characters",
      "templateContentRequired": "Template content is required",
      "templateContentTooLong": "Template content must be at most {{max}} characters",
      "invalidPlaceholder": "Unknown placeholder(s): {{placeholders}}"
    },
    "variableGroups": {
      "driver": "Customer",
      "store": "Store",
      "vehicle": "Vehicle",
      "order": "Order",
      "invoice": "Invoice",
      "employee": "Employee",
      "leave": "Leave",
      "timesheet": "Timesheet",
      "invite": "Invite",
      "booking": "Booking",
      "rentalBooking": "Rental Booking"
    }
  },
  "variants": {
    "title": "Service Variants",
    "description": "Manage pricing and scheduling variants for this service",
    "addVariant": "Add Variant",
    "editVariant": "Edit Variant",
    "deleteTitle": "Delete Variant",
    "deleteDesc": "Are you sure you want to delete this variant? This action cannot be undone.",
    "dialogDesc": "Configure the variant name, pricing, and day-specific durations.",
    "namePlaceholder": "e.g. Premium Package",
    "nameRequired": "Variant name is required",
    "cost": "Cost",
    "award": "Award",
    "currency": "Currency",
    "days": "Days",
    "totalDuration": "Total Duration",
    "scheduleDays": "Schedule Days",
    "empty": "No variants configured for this service.",
    "addFirst": "Add your first variant",
    "added": "Variant added successfully",
    "updated": "Variant updated successfully",
    "deleted": "Variant deleted successfully"
  },
  "qualifications": {
    "title": "Qualifications",
    "global": "Global",
    "local": "Store-Specific",
    "searchPlaceholder": "Search qualifications...",
    "addQualification": "Add Qualification",
    "addQualificationDesc": "Create a new qualification for your organization",
    "empty": "No qualifications found",
    "level": "Level",
    "validity": "Validity",
    "months": "months",
    "store": "Store",
    "created": "Qualification created successfully",
    "updated": "Qualification updated successfully",
    "deleted": "Qualification deleted successfully",
    "deleteConfirmTitle": "Delete Qualification",
    "deleteConfirmDesc": "This action cannot be undone. The qualification will be permanently deleted.",
    "levels": {
      "basic": "Basic",
      "intermediate": "Intermediate",
      "advanced": "Advanced",
      "expert": "Expert"
    },
    "form": {
      "basicInfo": "Basic Information",
      "basicInfoDesc": "Name and description of the qualification",
      "scopeLevel": "Scope & Level",
      "type": "Type",
      "typeDesc": "Global applies to all stores, Local is store-specific",
      "selectStore": "Select a store",
      "validityDesc": "How long this qualification remains valid (in months)",
      "additional": "Requirements & Status",
      "requirements": "Requirements",
      "requirementsPlaceholder": "e.g. Must complete 40h practical training...",
      "requirementsDesc": "Prerequisites or training needed for this qualification",
      "activeDesc": "Active qualifications can be assigned to staff and services",
      "namePlaceholder": "e.g. Certified Brake Specialist",
      "descriptionPlaceholder": "e.g. Certification for brake system inspection and repair",
      "nameRequired": "Name is required",
      "nameTooShort": "Name must be at least 3 characters",
      "nameTooLong": "Name must be at most 64 characters",
      "storeRequiredForLocal": "Store is required for local qualifications"
    },
    "serviceMapping": {
      "title": "Required Qualifications",
      "description": "Select qualifications required to perform this service",
      "noQualifications": "No qualifications assigned",
      "addQualification": "Add Qualification",
      "selectQualification": "Select a qualification"
    }
  },
  "reviews": {
    "title": "Reviews & Ratings",
    "subtitle": "View and manage customer feedback on completed jobs",
    "avgRating": "Avg Rating",
    "totalReviews": "Total Reviews",
    "recommendRate": "Recommend",
    "flagged": "Flagged",
    "ratingDistribution": "Rating Distribution",
    "searchPlaceholder": "Search reviews...",
    "filterStatus": "Status",
    "filterRating": "Rating",
    "published": "Published",
    "pending": "Pending",
    "flaggedStatus": "Flagged",
    "stars": "Stars",
    "noReviews": "No reviews found",
    "quality": "Quality",
    "service": "Service",
    "value": "Value",
    "wouldRecommend": "Would recommend",
    "wouldNotRecommend": "Would not recommend",
    "yourResponse": "Your Response",
    "submittedOn": "Submitted on",
    "submit": {
      "title": "How was your experience?",
      "subtitle": "Your feedback helps us improve our service",
      "forJob": "For job",
      "overallExperience": "Overall Experience",
      "overallDesc": "How would you rate your overall experience?",
      "overallRating": "Overall Rating",
      "detailedRatings": "Detailed Ratings",
      "writtenReview": "Your Review",
      "reviewTitle": "Review Title",
      "reviewTitlePlaceholder": "Summarize your experience",
      "reviewComment": "Your Comments",
      "reviewCommentPlaceholder": "Tell us more about your experience...",
      "wouldRecommend": "Would you recommend us to others?",
      "yourDetails": "Your Details",
      "yourName": "Your Name",
      "yourEmail": "Email Address",
      "submitReview": "Submit Review",
      "successTitle": "Review Submitted!",
      "successDesc": "Thank you for your feedback.",
      "thankYou": "Thank You!",
      "thankYouDesc": "Your review has been submitted successfully. We appreciate your feedback!"
    }
  },
  "myWork": {
    "title": "My Workspace",
    "description": "Track your work, leaves, and overtime",
    "logWork": "Log Work",
    "logWorkDesc": "Record your work hours for a day",
    "applyLeave": "Apply for Leave",
    "applyLeaveDesc": "Submit a leave request for approval",
    "submitRequest": "Submit Request",
    "leaveApplied": "Leave request submitted successfully",
    "workLogged": "Work log recorded successfully",
    "monthHours": "Month Hours",
    "overtimeHours": "Overtime",
    "presentDays": "Present Days",
    "leavesTaken": "Leaves Taken",
    "pendingRequests": "Pending",
    "avgHours": "Avg Hours",
    "perDay": "per day",
    "thisMonth": "This month",
    "overview": "Overview",
    "calendar": "Calendar",
    "leavesDashboard": "Leaves",
    "timesheet": "Timesheet",
    "overtimeLog": "Overtime",
    "todayStatus": "Today's Status",
    "notClockedIn": "Not clocked in yet",
    "leaveBalance": "Leave Balance",
    "used": "used",
    "total": "total",
    "remaining": "remaining",
    "recentActivity": "Recent Activity",
    "present": "Present",
    "leave": "Leave",
    "halfDay": "Half Day",
    "overtimeDay": "Overtime",
    "absent": "Absent",
    "selectDay": "Day Details",
    "clickDayToView": "Click a day on the calendar to view details",
    "leaveHistory": "Leave History",
    "appliedOn": "Applied",
    "by": "By",
    "totalOvertime": "Total Overtime",
    "overtimeDays": "OT Days",
    "daysWithOT": "days with overtime",
    "avgOvertime": "Avg OT",
    "perOvertimeDay": "per overtime day",
    "overtimeHistory": "Overtime History",
    "weeklyTrend": "Hours Trend (Last 14 working days)",
    "monthlyGoal": "Monthly Goal",
    "goalSubtitle": "Target: 160 hours / month"
  },
  "teamView": {
    "title": "Team Overview",
    "description": "Monitor team performance, attendance, and leave management",
    "teamStatus": "Team Status",
    "leaveApprovals": "Leave Approvals",
    "attendance": "Attendance",
    "totalTeam": "Total Team",
    "pendingLeaves": "Pending Leaves",
    "pendingApprovals": "Pending Approvals",
    "awaitingApproval": "awaiting approval",
    "searchEmployee": "Search employee...",
    "noEmployees": "No employees found",
    "weekHours": "Week Hours",
    "leavesUsed": "Leaves Used",
    "today": "Today",
    "week": "Week",
    "month": "Month",
    "approve": "Approve",
    "reject": "Reject",
    "approveLeave": "Approve Leave Request",
    "rejectLeave": "Reject Leave Request",
    "rejectReason": "Reason for rejection",
    "rejectReasonPlaceholder": "Provide a reason for rejecting this leave request...",
    "confirmApprove": "Confirm Approval",
    "confirmReject": "Confirm Rejection",
    "leaveApproved": "Leave request approved",
    "leaveRejected": "Leave request rejected",
    "noLeaveRequests": "No leave requests",
    "workloadDistribution": "Workload Distribution (Today)",
    "topPerformers": "Top Performers"
  },
  "myWorkspace": {
    "tabs": {
      "overview": "Overview",
      "leaves": "Leaves",
      "timesheet": "My Timesheet",
      "overtime": "Overtime",
      "salaries": "Salaries"
    },
    "salarySlip": {
      "title": "Salary Slip",
      "payPeriod": "Pay Period",
      "employeeName": "Employee Name",
      "employeeEmail": "Employee Email",
      "employeeId": "Employee ID",
      "payDate": "Pay Date",
      "earnings": "Earnings",
      "baseSalary": "Base Salary",
      "hra": "HRA",
      "allowances": "Allowances",
      "bonus": "Bonus",
      "gross": "Gross",
      "deductions": "Deductions",
      "incomeTax": "Income Tax",
      "pension": "Pension",
      "insurance": "Insurance",
      "total": "Total",
      "netPay": "Net Pay",
      "disclaimer": "This is a computer-generated salary slip and does not require a signature.",
      "downloaded": "Salary slip downloaded",
      "exportFailed": "Failed to export PDF",
      "months": {
        "jan": "January",
        "feb": "February",
        "mar": "March",
        "apr": "April",
        "may": "May",
        "jun": "June",
        "jul": "July",
        "aug": "August",
        "sep": "September",
        "oct": "October",
        "nov": "November",
        "dec": "December"
      }
    }
  },
  "teamHub": {
    "tabs": {
      "team": "Team Status",
      "approvals": "Approvals",
      "calendar": "Team Calendar"
    },
    "calendar": {
      "title": "Team Calendar",
      "description": "Working hours, vacations, sick leave and other absences across your team"
    }
  },
  "packages": {
    "title": "Packages",
    "description": "Bundle services and products into sellable packages with variants",
    "addPackage": "New Package",
    "addPackageDesc": "Create a new package with variants, services and products",
    "searchPlaceholder": "Search packages...",
    "empty": "No packages found",
    "notFound": "Package not found",
    "created": "Package created",
    "updated": "Package updated",
    "validity": "Validity",
    "fromDate": "Valid From",
    "toDate": "Valid To",
    "status": {
      "active": "Active",
      "inactive": "Inactive",
      "archived": "Archived"
    },
    "form": {
      "basicInfo": "Basic Information",
      "basicInfoDesc": "General details about this package",
      "namePlaceholder": "e.g. Basic Maintenance Bundle",
      "descriptionPlaceholder": "What's included and who is it for",
      "nameRequired": "Name is required",
      "nameTooLong": "Name must be at most {{max}} characters",
      "variantNameRequired": "Variant name is required",
      "variantNameTooLong": "Variant name must be at most {{max}} characters",
      "priceRequired": "Price is required",
      "priceInvalid": "Price must be a number with up to 2 decimals, e.g. 199.00",
      "currencyRequired": "Currency is required",
      "currencyTooLong": "Currency must be at most {{max}} characters",
      "serviceRequired": "Select a service",
      "productRequired": "Select a product",
      "quantityMin": "Quantity must be at least 1",
      "mustBeWholeNumber": "Must be a whole number",
      "durationMin": "Duration must be at least 1 minute"
    },
    "variants": {
      "title": "Variants",
      "desc": "Each variant defines a price, duration and a set of services/products",
      "add": "Add Variant",
      "empty": "No variants yet. Add one to define pricing.",
      "namePlaceholder": "e.g. Petrol / Diesel / Small",
      "price": "Price",
      "currency": "Currency",
      "duration": "Duration (min)",
      "sortOrder": "Sort Order",
      "remove": "Delete variant"
    },
    "services": {
      "title": "Services",
      "add": "Add Service",
      "empty": "No services in this variant",
      "selectVariant": "Select variant",
      "noVariant": "No variants",
      "selectService": "Select service",
      "remove": "Remove service"
    },
    "products": {
      "title": "Products",
      "add": "Add Product",
      "empty": "No products in this variant",
      "selectProduct": "Select product",
      "remove": "Remove product"
    }
  },
  "absenceTypes": {
    "title": "Absence Types",
    "description": "Define types of absences employees can request",
    "add": "New Absence Type",
    "addDesc": "Create a new type of absence for your organization",
    "searchPlaceholder": "Search absence types...",
    "empty": "No absence types found",
    "notFound": "Absence type not found",
    "created": "Absence type created",
    "updated": "Absence type updated",
    "deleted": "Absence type deleted",
    "deleteConfirmTitle": "Delete absence type?",
    "deleteConfirmDesc": "This action cannot be undone. The absence type will be permanently deleted.",
    "code": "Code",
    "requiresApproval": "Requires Approval",
    "requiresDocumentation": "Requires Documentation",
    "isPaid": "Paid Absence",
    "allowPartialDay": "Allow Partial Day",
    "advanceNoticeDays": "Advance Notice (days)",
    "annualLimitDays": "Annual Limit (days)",
    "colorCode": "Color Code",
    "status": {
      "active": "Active",
      "inactive": "Inactive",
      "draft": "Draft",
      "terminated": "Terminated"
    },
    "form": {
      "basicInfo": "Basic Information",
      "basicInfoDesc": "General details about this absence type",
      "rules": "Rules & Configuration",
      "rulesDesc": "Define approval, documentation and pay rules",
      "limits": "Limits",
      "limitsDesc": "Set advance notice and annual day limits",
      "namePlaceholder": "e.g. Annual Leave",
      "codePlaceholder": "e.g. AL",
      "descriptionPlaceholder": "Describe this absence type",
      "colorCodePlaceholder": "#000000",
      "annualLimitNone": "No limit",
      "nameRequired": "Name is required",
      "nameTooLong": "Name must be at most {{max}} characters",
      "codeRequired": "Code is required",
      "codeTooLong": "Code must be at most {{max}} characters",
      "descriptionTooLong": "Description must be at most {{max}} characters",
      "mustBeWholeNumber": "Must be a whole number",
      "mustBePositive": "Must be 0 or greater",
      "maxDays": "Must be {{max}} days or fewer",
      "colorCodeInvalid": "Must be a hex color like #1A2B3C"
    }
  },
  "unionAgreements": {
    "title": "Union Agreements",
    "description": "Manage collective union agreements applied to employees.",
    "add": "New Agreement",
    "addDesc": "Define a new union agreement and its terms.",
    "created": "Union agreement created",
    "updated": "Union agreement updated",
    "deleted": "Agreement deleted",
    "empty": "No union agreements yet.",
    "searchPlaceholder": "Search agreements…",
    "deleteConfirmTitle": "Delete agreement?",
    "deleteConfirmDesc": "This action cannot be undone. The union agreement will be permanently deleted.",
    "validity": "Validity",
    "startAt": "Start date",
    "endAt": "End date",
    "days": "days",
    "vacationDays": "Vacation days",
    "hoursPerWeek": "Hours / week",
    "hourlyRate": "Hourly rate",
    "hourlyRatePlaceholder": "e.g. 250",
    "limitationPeriod": "Limitation period",
    "limitationPeriodDesc": "Apply statutory limitation period rules.",
    "dayRest": "Daily rest (hours)",
    "weekRest": "Weekly rest (hours)",
    "onCallTime": "On-call time (hours)",
    "sickDays": "Sick days",
    "sickHours": "Sick hours",
    "maxMonthlyOverTime": "Max monthly overtime (hours)",
    "maxFourWeekOvertime": "Max 4-week overtime (hours)",
    "maxAnnulOverTime": "Max annual overtime (hours)",
    "maxAnnualExceptionalOverTime": "Max annual exceptional overtime (hours)",
    "status": {
      "Active": "Active",
      "Inactive": "Inactive",
      "Blacklisted": "Blacklisted"
    },
    "form": {
      "basicInfo": "Basic Information",
      "basicInfoDesc": "Identification and validity of the union agreement.",
      "namePlaceholder": "e.g. Metall Workshop Agreement 2024",
      "workingTime": "Working time",
      "workingTimeDesc": "Standard hours, vacation and rest periods.",
      "sickLeave": "Sick leave",
      "overtime": "Overtime limits",
      "overtimeDesc": "Maximum overtime allowed in different periods.",
      "nameRequired": "Name is required",
      "nameTooLong": "Name must be at most {{max}} characters",
      "startAtRequired": "Start date is required",
      "endAtRequired": "End date is required",
      "mustBeWholeNumber": "Must be a whole number",
      "mustBePositive": "Must be 0 or greater",
      "maxHours": "Must be {{max}} hours or fewer",
      "maxDays": "Must be {{max}} days or fewer"
    }
  },
  "overtime": {
    "created": "Overtime registered",
    "register": {
      "title": "Register Overtime",
      "date": "Date",
      "timeRange": "Time Range",
      "commentPlaceholder": "Optional note...",
      "submit": "Register Overtime"
    }
  },
  "staffAttendance": {
    "registerAbsence": "Register Absence",
    "registerOvertime": "Register Overtime",
    "searchEmployee": "Search employee...",
    "editedShift": "Edited shift",
    "hours": "Hours",
    "editShift": "Edit Shift",
    "break": "Break (min)",
    "repeat": "Repeat",
    "doesNotRepeat": "Does not repeat",
    "weekly": "Weekly",
    "shiftSaved": "Shift saved",
    "noEmployees": "No employees found"
  },
  "changePassword": {
    "subtitle": "Update your password to keep your account secure",
    "passwordSecurity": "Password Security",
    "changePasswordTitle": "Change Password",
    "chooseStrong": "Choose a strong password that you don't use elsewhere",
    "currentPassword": "Current Password",
    "currentPasswordPlaceholder": "Enter current password",
    "currentPasswordRequired": "Current password is required",
    "confirmNewPasswordRequired": "Please confirm your new password",
    "newPasswordPlaceholder": "Enter new password",
    "requirementsTitle": "Password requirements:",
    "req8Chars": "At least 8 characters",
    "reqUppercase": "Contains uppercase letter",
    "reqLowercase": "Contains lowercase letter",
    "reqNumber": "Contains a number",
    "reqSpecial": "Contains special character",
    "confirmNewPassword": "Confirm New Password",
    "confirmNewPasswordPlaceholder": "Confirm new password",
    "passwordsDoNotMatch": "Passwords do not match",
    "newPasswordsMismatchToast": "New passwords do not match",
    "meetRequirementsToast": "Please meet all password requirements",
    "updateSuccessToast": "Password changed successfully",
    "updateFailedToast": "Failed to update password",
    "updatePassword": "Update Password"
  },
  "account": {
    "tabs": {
      "profile": "Profile",
      "workingHours": "Working Hours",
      "security": "Security",
      "loginHistory": "Login History"
    },
    "profilePicture": "Profile Picture",
    "updateProfilePhoto": "Update your profile photo",
    "uploadPhoto": "Upload photo",
    "photoHint": "JPG, GIF or PNG. Max size 2MB.",
    "avatarUpdatedToast": "Profile photo updated",
    "personalInformation": "Personal Information",
    "updatePersonalDetails": "Update your personal details",
    "emailAddress": "Email Address",
    "saveChanges": "Save Changes",
    "profileUpdatedToast": "Profile updated successfully",
    "changesDiscardedToast": "Changes discarded",
    "regularWorkingHours": "Regular Working Hours",
    "workingHoursDesc": "Set your standard weekly schedule. Leave times empty for non-working days.",
    "workingHoursUpdatedToast": "Working hours updated",
    "workingHoursSaveFailedToast": "Failed to save working hours",
    "workingHoursSavePartialFailedToast": "Some working hours failed to save. Please review and try again.",
    "workingHoursNoContextHint": "Working hours aren't available — your account isn't linked to a store or employee profile.",
    "workingHoursReadOnlyHint": "You have read-only access to working hours. Contact an administrator to make changes.",
    "day": "Day",
    "startTime": "Start Time",
    "endTime": "End Time",
    "restTime": "Rest (hh:mm)",
    "twoFactorAuth": "Two-Factor Authentication",
    "twoFactorDesc": "Add an extra layer of security to your account",
    "authenticatorApp": "Authenticator App",
    "authenticatorDesc": "Use an authenticator app to generate one-time codes",
    "enable": "Enable",
    "biometricLock": {
      "title": "Biometric App Lock",
      "description": "Require Face ID, Touch ID, or fingerprint to unlock the app after it returns from the background.",
      "toggleLabel": "Require biometric unlock",
      "toggleDesc": "You'll be asked to verify with your device's biometrics whenever the app returns from the background."
    },
    "loginHistoryTitle": "Login History",
    "loginHistoryDesc": "Recent login activity on your account",
    "noLoginHistory": "No login history yet"
  },
  "appLock": {
    "title": "App Locked",
    "description": "Verify with your device's biometrics to continue.",
    "verificationFailed": "Verification failed or was cancelled. Please try again.",
    "unlock": "Unlock",
    "retry": "Retry",
    "logOut": "Log Out"
  },
  "pdfPreview": {
    "back": "Back",
    "download": "Download",
    "pageAlt": "Page {{page}}"
  },
  "economy": {
    "title": "Economy",
    "description": "Invoices, payments, and payroll",
    "sync": "Sync",
    "syncedToast": "Synced with accounting",
    "exportStartedToast": "Export started",
    "drafts": "Drafts",
    "totalDraftValue": "Total Draft Value",
    "avgDraftValue": "Avg Draft Value",
    "invoicesTab": "Invoices",
    "paymentsTab": "Payments",
    "timeReportsTab": "Time Reports",
    "searchPlaceholder": "Search by job ID, customer, vehicle...",
    "noDrafts": "No drafts",
    "noInvoices": "No invoices",
    "noPayments": "No payments",
    "noReports": "No reports",
    "columns": {
      "jobId": "Job ID",
      "customer": "Customer",
      "vehicle": "Vehicle",
      "services": "Services",
      "parts": "Parts",
      "labor": "Labor",
      "total": "Total",
      "status": "Status",
      "invoiceNumber": "Invoice #",
      "amount": "Amount",
      "dueDate": "Due Date",
      "reference": "Reference",
      "method": "Method",
      "date": "Date",
      "employee": "Employee",
      "period": "Period",
      "hours": "Hours",
      "overtime": "Overtime"
    },
    "draftBadge": "Draft",
    "detail": {
      "draftTitle": "Draft · {{id}}",
      "invoiceTitle": "Invoice · {{id}}",
      "paymentTitle": "Payment · {{id}}",
      "timeReportTitle": "Time Report · {{id}}",
      "draftDesc": "Draft invoice ready for review",
      "invoiceDesc": "Invoice details and payment status",
      "paymentDesc": "Payment transaction details",
      "timeReportDesc": "Employee time report breakdown",
      "regularHours": "Regular Hours",
      "sendInvoice": "Send Invoice",
      "sendInvoiceToast": "Draft sent as invoice",
      "editedToast": "Draft edited",
      "sendReminder": "Send Reminder",
      "reminderSentToast": "Reminder sent",
      "pdf": "PDF",
      "downloadedToast": "Downloaded",
      "sendReceipt": "Send Receipt",
      "receiptSentToast": "Receipt sent",
      "approve": "Approve",
      "approvedToast": "Approved",
      "reject": "Reject",
      "rejectedToast": "Rejected"
    }
  },
  "checkIn": {
    "atWorkNow": "At Work Now",
    "lateArrivals": "Late Arrivals",
    "missingPunches": "Missing Punches",
    "allStatus": "All Status",
    "statusIn": "In",
    "statusOut": "Out",
    "allTypes": "All Types",
    "typeLive": "Live",
    "typeManual": "Manual",
    "typeAdjusted": "Adjusted",
    "employee": "Employee",
    "sessions": "Sessions",
    "totalHours": "Total Hours",
    "noEntriesFound": "No entries found",
    "sessionDeleted": "Session deleted",
    "attendanceSessions": "Attendance Sessions",
    "addMissingPunch": "Add Missing Punch",
    "session": "Session {{n}}",
    "duration": "Duration:",
    "notes": "Notes",
    "notesPlaceholder": "Add notes about this attendance record...",
    "scheduled": "Scheduled"
  },
  "teamApprovals": {
    "status": {
      "pending": "Pending",
      "approved": "Approved",
      "rejected": "Rejected",
      "onHold": "On Hold"
    },
    "allMonths": "All months",
    "allStatuses": "All statuses",
    "grossTotal": "Gross total",
    "month": "Month",
    "regularHours": "Regular hours",
    "overtimeHours": "Overtime hours",
    "hourlyRate": "Hourly rate",
    "overtimeRate": "Overtime rate (×1.5)",
    "baseSalary": "Base salary",
    "overtimePay": "Overtime pay",
    "commission": "Commission",
    "leavesTab": "Leaves",
    "timesheetsTab": "Timesheets",
    "noLeaveRequests": "No leave requests",
    "noTimesheetSubmissions": "No timesheet submissions",
    "appliedPrefix": "Applied",
    "daysSuffix": "days",
    "total": "Total",
    "regular": "Regular",
    "otAbbr": "OT",
    "hold": "Hold",
    "reject": "Reject",
    "approve": "Approve",
    "noteLabel": "Note:",
    "approveRequestTitle": "Approve request",
    "rejectRequestTitle": "Reject request",
    "holdRequestTitle": "Place request on hold",
    "reasonForRejection": "Reason for rejection",
    "noteOptional": "Note (optional)",
    "provideReasonPlaceholder": "Provide a reason...",
    "whyOnHoldPlaceholder": "Why is this on hold?",
    "confirmApproval": "Confirm Approval",
    "confirmRejection": "Confirm Rejection",
    "placeOnHold": "Place On Hold",
    "editing": "Editing",
    "timesheetTab": "Timesheet",
    "salaryTab": "Salary",
    "leaveDetails": "Leave details",
    "overtimeDetails": "Overtime details",
    "period": "Period",
    "duration": "Duration",
    "hours": "Hours",
    "job": "Job",
    "appliedOn": "Applied on",
    "reasonSection": "Reason",
    "managerNote": "Manager note",
    "employeeSection": "Employee",
    "role": "Role",
    "requestApprovedToast": "Request approved",
    "requestRejectedToast": "Request rejected",
    "requestOnHoldToast": "Request placed on hold"
  }
}
